var items = {
  "block.minecraft.acacia_button": "Acacia Button",
  "block.minecraft.acacia_door": "Acacia albaabka",
  "block.minecraft.acacia_fence": "Acacia Fence",
  "block.minecraft.acacia_fence_gate": "Albaabka Acacia Fence",
  "block.minecraft.acacia_hanging_sign": "Calaamada Laalaada Acacia",
  "block.minecraft.acacia_leaves": "Acacia Leaves",
  "block.minecraft.acacia_log": "Diiwaanka Acacia",
  "block.minecraft.acacia_planks": "Qorshaha Acacia",
  "block.minecraft.acacia_pressure_plate": "Cadaadiska Cadaadiska Acacia",
  "block.minecraft.acacia_sapling": "Acacia sapling",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Acacia saxiix",
  "block.minecraft.acacia_slab": "Qudhac ah Xargaha",
  "block.minecraft.acacia_stairs": "Qudhac ah Jaranjaro",
  "block.minecraft.acacia_trapdoor": "Acacia Trapdoor",
  "block.minecraft.acacia_wall_hanging_sign": "Calaamada Laadlaadsan ee Acacia Wall",
  "block.minecraft.acacia_wall_sign": "Calaamadda derbiga acacia",
  "block.minecraft.acacia_wood": "Acacia alwaax",
  "block.minecraft.activator_rail": "Activator Rail",
  "block.minecraft.air": "Hawo",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Baloogga Ametusti",
  "block.minecraft.amethyst_cluster": "Kooxda Amethyst",
  "block.minecraft.ancient_debris": "Ancient Debris",
  "block.minecraft.andesite": "Andesite",
  "block.minecraft.andesite_slab": "Weelka iyo weelka",
  "block.minecraft.andesite_stairs": "Jaranjaro iyo jaranjaro",
  "block.minecraft.andesite_wall": "Derbiga iyo weelka",
  "block.minecraft.anvil": "Anvil",
  "block.minecraft.attached_melon_stem": "Qaraha qaraha ee ku lifaaqan",
  "block.minecraft.attached_pumpkin_stem": "Stem Pumpkin Stem",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azalea Caleemaha",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Dhir dheer",
  "block.minecraft.bamboo_block": "Block of Bamboo",
  "block.minecraft.bamboo_button": "Badhanka Bamboo",
  "block.minecraft.bamboo_door": "Albaabka Bamboo",
  "block.minecraft.bamboo_fence": "Xayndaabka Bamboo",
  "block.minecraft.bamboo_fence_gate": "Albaabka Xayndaabka Bamboo",
  "block.minecraft.bamboo_hanging_sign": "Calaamadda Bamboo Laalaada",
  "block.minecraft.bamboo_mosaic": "Bambo Mosaic",
  "block.minecraft.bamboo_mosaic_slab": "Bamboo Mosaic Slab",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboo Mosaic Stairs",
  "block.minecraft.bamboo_planks": "Looxyada Bamboo",
  "block.minecraft.bamboo_pressure_plate": "Saxanka Cadaadiska Bamboo",
  "block.minecraft.bamboo_sapling": "Bamboo Shoot",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Calaamada Bamboo",
  "block.minecraft.bamboo_slab": "Bamboo Slab",
  "block.minecraft.bamboo_stairs": "Jaranjarada Bamboo",
  "block.minecraft.bamboo_trapdoor": "Bamboo Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Calaamadda gidaarka Bamboo",
  "block.minecraft.bamboo_wall_sign": "Calaamadda gidaarka Bamboo",
  "block.minecraft.banner.base.black": "Field Madaw",
  "block.minecraft.banner.base.blue": "Goob Buuxda Oo Buluug ah",
  "block.minecraft.banner.base.brown": "Goob Buuxi Buuran",
  "block.minecraft.banner.base.cyan": "Fiidiyow Cyan",
  "block.minecraft.banner.base.gray": "Goob buuxda oo Cawl ah",
  "block.minecraft.banner.base.green": "Goob Cagaaran Oo Buuxda",
  "block.minecraft.banner.base.light_blue": "Goob Buluug Buuxda leh",
  "block.minecraft.banner.base.light_gray": "Fiidiyow Cawl Fiican",
  "block.minecraft.banner.base.lime": "Dhulka Lime Buuxda",
  "block.minecraft.banner.base.magenta": "Field Magenta Field",
  "block.minecraft.banner.base.orange": "Goobta Liinta Oo Dhamaystiran",
  "block.minecraft.banner.base.pink": "Goob Fulin Casaan Leh",
  "block.minecraft.banner.base.purple": "Goob Buuxa Oo Buuxda",
  "block.minecraft.banner.base.red": "Field Gaduudan",
  "block.minecraft.banner.base.white": "Goob Cadaan Ah Oo Buuxda",
  "block.minecraft.banner.base.yellow": "Goob Jaale Buuxda",
  "block.minecraft.banner.border.black": "Shinbiraha waa qabow",
  "block.minecraft.banner.border.blue": "Bordure buluug",
  "block.minecraft.banner.border.brown": "Bordure Brown",
  "block.minecraft.banner.border.cyan": "Cyan Bordure",
  "block.minecraft.banner.border.gray": "Bordure cawl",
  "block.minecraft.banner.border.green": "Bordure cagaaran",
  "block.minecraft.banner.border.light_blue": "Bordure buluug khafiif ah",
  "block.minecraft.banner.border.light_gray": "Bordure cawlan khafiif ah",
  "block.minecraft.banner.border.lime": "Bordure lime",
  "block.minecraft.banner.border.magenta": "Magenta Bordure",
  "block.minecraft.banner.border.orange": "Bordure Orange",
  "block.minecraft.banner.border.pink": "Bordure casaan",
  "block.minecraft.banner.border.purple": "Bordure Purple",
  "block.minecraft.banner.border.red": "Bordure cas",
  "block.minecraft.banner.border.white": "Bordure cad",
  "block.minecraft.banner.border.yellow": "Jaalle Bordure",
  "block.minecraft.banner.bricks.black": "Beerta Madow ee Masoned",
  "block.minecraft.banner.bricks.blue": "Beerta Buluugga ah ee la dhisay",
  "block.minecraft.banner.bricks.brown": "Goobta Brown ee Masoned",
  "block.minecraft.banner.bricks.cyan": "Cyan Field Masoned",
  "block.minecraft.banner.bricks.gray": "Grey Field Masoned",
  "block.minecraft.banner.bricks.green": "Beerta Cagaaran Masoned",
  "block.minecraft.banner.bricks.light_blue": "Beerta Buluugga ah ee Fudud ee Masoned",
  "block.minecraft.banner.bricks.light_gray": "Beerta Cawlan ee Fudud ee Masoned",
  "block.minecraft.banner.bricks.lime": "Beerta Lime Masoned",
  "block.minecraft.banner.bricks.magenta": "Magenta Field Masoned",
  "block.minecraft.banner.bricks.orange": "Beerta Orange Masoned",
  "block.minecraft.banner.bricks.pink": "Meesha casaanka ah ee la sameeyay",
  "block.minecraft.banner.bricks.purple": "Beerta Purple Masoned",
  "block.minecraft.banner.bricks.red": "Beerta gaduudan Masoned",
  "block.minecraft.banner.bricks.white": "Beerta Cadaanka Masoned",
  "block.minecraft.banner.bricks.yellow": "Beerta Jaalaha Masoned",
  "block.minecraft.banner.circle.black": "Madow Roundel",
  "block.minecraft.banner.circle.blue": "Buluug Roundel",
  "block.minecraft.banner.circle.brown": "Bunni Roundel",
  "block.minecraft.banner.circle.cyan": "Cawlan Roundel",
  "block.minecraft.banner.circle.gray": "Cawlan Roundel",
  "block.minecraft.banner.circle.green": "Cagaaran Roundel",
  "block.minecraft.banner.circle.light_blue": "Buluug khafiif ah Roundel",
  "block.minecraft.banner.circle.light_gray": "Cawl khafiif ah Roundel",
  "block.minecraft.banner.circle.lime": "Cagaar jaale ah Roundel",
  "block.minecraft.banner.circle.magenta": "Magenta wareega",
  "block.minecraft.banner.circle.orange": "Cawlan Roundel",
  "block.minecraft.banner.circle.pink": "Casaan Roundel",
  "block.minecraft.banner.circle.purple": "Guduudan Roundel",
  "block.minecraft.banner.circle.red": "Casaan Roundel",
  "block.minecraft.banner.circle.white": "Roundel cad",
  "block.minecraft.banner.circle.yellow": "Jaale Roundel",
  "block.minecraft.banner.creeper.black": "Black Creeper Charge",
  "block.minecraft.banner.creeper.blue": "Lacagta Creeper Blue",
  "block.minecraft.banner.creeper.brown": "Lacagta Creeper Brown",
  "block.minecraft.banner.creeper.cyan": "Cyan Creeper Charge",
  "block.minecraft.banner.creeper.gray": "Lacag Creeper Cawlan",
  "block.minecraft.banner.creeper.green": "Red Creeper Charge",
  "block.minecraft.banner.creeper.light_blue": "Kharashka Creeper ee Cawlan fudud",
  "block.minecraft.banner.creeper.light_gray": "Kharashka Creeper ee Cawlan fudud",
  "block.minecraft.banner.creeper.lime": "Lacagta Creeper White",
  "block.minecraft.banner.creeper.magenta": "Qiimaha Ubaxa Magenta",
  "block.minecraft.banner.creeper.orange": "Lacag Creeper Cawlan",
  "block.minecraft.banner.creeper.pink": "Lacagta Creeper White",
  "block.minecraft.banner.creeper.purple": "Purple Creeper Charge",
  "block.minecraft.banner.creeper.red": "Black Creeper Charge",
  "block.minecraft.banner.creeper.white": "Lacagta Creeper White",
  "block.minecraft.banner.creeper.yellow": "Lacagta Ubax Jaallaha ah",
  "block.minecraft.banner.cross.black": "Madow Iskutallaab",
  "block.minecraft.banner.cross.blue": "Buluug Iskutallaab",
  "block.minecraft.banner.cross.brown": "Bunni Iskutallaab",
  "block.minecraft.banner.cross.cyan": "Cyan Iskutallaab",
  "block.minecraft.banner.cross.gray": "Dameeri Iskutallaab",
  "block.minecraft.banner.cross.green": "Akhtar Iskutallaab",
  "block.minecraft.banner.cross.light_blue": "Iftiin Buluug Iskutallaab",
  "block.minecraft.banner.cross.light_gray": "Iftiin Dameeri Iskutallaab",
  "block.minecraft.banner.cross.lime": "Lime Iskutallaab",
  "block.minecraft.banner.cross.magenta": "Magenta Iskutallaab",
  "block.minecraft.banner.cross.orange": "Liimi Iskutallaab",
  "block.minecraft.banner.cross.pink": "Basali Iskutallaab",
  "block.minecraft.banner.cross.purple": "Carwaajis Iskutallaab",
  "block.minecraft.banner.cross.red": "Casaan Iskutallaab",
  "block.minecraft.banner.cross.white": "Caddaan Iskutallaab",
  "block.minecraft.banner.cross.yellow": "Jaalle Iskutallaab",
  "block.minecraft.banner.curly_border.black": "Buluug Bordure Indented",
  "block.minecraft.banner.curly_border.blue": "Buluug Bordure Indented",
  "block.minecraft.banner.curly_border.brown": "Cagaaran Bordure Indented",
  "block.minecraft.banner.curly_border.cyan": "Grey Bordure waa la soo galay",
  "block.minecraft.banner.curly_border.gray": "Cagaaran Bordure Indented",
  "block.minecraft.banner.curly_border.green": "Cagaaran Bordure Indented",
  "block.minecraft.banner.curly_border.light_blue": "Iftiinka Cawlan Bordure Indented",
  "block.minecraft.banner.curly_border.light_gray": "Iftiin Dameeri Hirarka Aasaasiga",
  "block.minecraft.banner.curly_border.lime": "Caddaan Bordure Indented",
  "block.minecraft.banner.curly_border.magenta": "Cagaaran Bordure Indented",
  "block.minecraft.banner.curly_border.orange": "Cagaaran Bordure Indented",
  "block.minecraft.banner.curly_border.pink": "Caddaan Bordure Indented",
  "block.minecraft.banner.curly_border.purple": "Cagaaran Bordure Indented",
  "block.minecraft.banner.curly_border.red": "Casaan Bordure Indented",
  "block.minecraft.banner.curly_border.white": "Caddaan Bordure Indented",
  "block.minecraft.banner.curly_border.yellow": "Jaalle Hirarka Aasaasiga",
  "block.minecraft.banner.diagonal_left.black": "Madow Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.blue": "Buluug Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.brown": "Bunni Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Cyan Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.gray": "Dameeri Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.green": "Akhtar Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Iftiin Buluug Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Iftiin Dameeri Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.lime": "Lime Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.orange": "Liimi Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.pink": "Basali Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.purple": "Carwaajis Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.red": "Casaan Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.white": "Caddaan Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Jaalle Per Bend Sinister",
  "block.minecraft.banner.diagonal_right.black": "Madow Per Bend",
  "block.minecraft.banner.diagonal_right.blue": "Buluug Per Bend",
  "block.minecraft.banner.diagonal_right.brown": "Bunni Per Bend",
  "block.minecraft.banner.diagonal_right.cyan": "Cyan Per Bend",
  "block.minecraft.banner.diagonal_right.gray": "Dameeri Per Bend",
  "block.minecraft.banner.diagonal_right.green": "Akhtar Per Bend",
  "block.minecraft.banner.diagonal_right.light_blue": "Iftiin Buluug Per Bend",
  "block.minecraft.banner.diagonal_right.light_gray": "Iftiin Dameeri Per Bend",
  "block.minecraft.banner.diagonal_right.lime": "Lime Per Bend",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta Per Bend",
  "block.minecraft.banner.diagonal_right.orange": "Liimi Per Bend",
  "block.minecraft.banner.diagonal_right.pink": "Basali Per Bend",
  "block.minecraft.banner.diagonal_right.purple": "Carwaajis Per Bend",
  "block.minecraft.banner.diagonal_right.red": "Casaan Per Bend",
  "block.minecraft.banner.diagonal_right.white": "Caddaan Per Bend",
  "block.minecraft.banner.diagonal_right.yellow": "Jaalle Per Bend",
  "block.minecraft.banner.diagonal_up_left.black": "Madow Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.blue": "Buluug Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.brown": "Bunni Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyan Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.gray": "Dameeri Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.green": "Akhtar Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Iftiin Buluug Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Iftiin Dameeri Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.lime": "Lime Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.orange": "Liimi Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.pink": "Basali Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.purple": "Carwaajis Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.red": "Casaan Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.white": "Caddaan Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_left.yellow": "Jaalle Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.black": "Madow Per Bend Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.blue": "Buluug Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.brown": "Bunni",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyan Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.gray": "Dameeri Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.green": "Akhtar Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Iftiin Buluug Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Iftiin Dameeri Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.lime": "Lime Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.orange": "Liimi Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.pink": "Basali Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.purple": "Carwaajis Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.red": "Casaan Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.white": "Caddaan Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.diagonal_up_right.yellow": "Jaalle Per Bend Sinister Soo Jeestay",
  "block.minecraft.banner.flow.black": "Madow khadka dhexe",
  "block.minecraft.banner.flow.blue": "Madow khadka dhexe",
  "block.minecraft.banner.flow.brown": "Bunni khadka dhexe",
  "block.minecraft.banner.flow.cyan": "Cyan Globe",
  "block.minecraft.banner.flow.gray": "Cawlan khadka dhexe",
  "block.minecraft.banner.flow.green": "Cagaar khadka dhexe",
  "block.minecraft.banner.flow.light_blue": "Iftiin Buluug Khadka Dhexe",
  "block.minecraft.banner.flow.light_gray": "Iftiin Dameeri Khadka Dhexe",
  "block.minecraft.banner.flow.lime": "Lime Globe",
  "block.minecraft.banner.flow.magenta": "Magenta Khadka Dhexe",
  "block.minecraft.banner.flow.orange": "Liimi Khadka Dhexe",
  "block.minecraft.banner.flow.pink": "Pink Globe",
  "block.minecraft.banner.flow.purple": "Carwaajis Khadka Dhexe",
  "block.minecraft.banner.flow.red": "Casaan Khadka Dhexe",
  "block.minecraft.banner.flow.white": "Caddaan Khadka Dhexe",
  "block.minecraft.banner.flow.yellow": "Jaalle Khadka Dhexe",
  "block.minecraft.banner.flower.black": "Qiimaha Ubaxa Buluugga ah",
  "block.minecraft.banner.flower.blue": "Qiimaha Ubaxa Buluugga ah",
  "block.minecraft.banner.flower.brown": "Qiimaha Ubaxa Buluugga ah",
  "block.minecraft.banner.flower.cyan": "Lacagta Ubax Cawlan",
  "block.minecraft.banner.flower.gray": "Kharashka Ubax Cagaaran",
  "block.minecraft.banner.flower.green": "Kharashka Ubax Cagaaran",
  "block.minecraft.banner.flower.light_blue": "Kharashka Ubax Cawlan Fudud",
  "block.minecraft.banner.flower.light_gray": "Kharashka Ubax Cawlan Fudud",
  "block.minecraft.banner.flower.lime": "Qiimaha ubaxa lime",
  "block.minecraft.banner.flower.magenta": "Qiimaha Ubaxa Magenta",
  "block.minecraft.banner.flower.orange": "Qiimaha Ubax Orange",
  "block.minecraft.banner.flower.pink": "Qiimaha Ubax Pink",
  "block.minecraft.banner.flower.purple": "Kharashka Ubax Purple",
  "block.minecraft.banner.flower.red": "Lacagta Ubax Cas",
  "block.minecraft.banner.flower.white": "Lacagta Ubax Cad",
  "block.minecraft.banner.flower.yellow": "Lacagta Ubax Jaallaha ah",
  "block.minecraft.banner.globe.black": "Black Globe",
  "block.minecraft.banner.globe.blue": "Blue Globe",
  "block.minecraft.banner.globe.brown": "Brown Globe",
  "block.minecraft.banner.globe.cyan": "Cyan Globe",
  "block.minecraft.banner.globe.gray": "Gray Globe",
  "block.minecraft.banner.globe.green": "Green Globe",
  "block.minecraft.banner.globe.light_blue": "Iftiin Buluuga Globe",
  "block.minecraft.banner.globe.light_gray": "Iftiinka Gray Globe",
  "block.minecraft.banner.globe.lime": "Lime Globe",
  "block.minecraft.banner.globe.magenta": "Magenta Globe",
  "block.minecraft.banner.globe.orange": "Orange Globe",
  "block.minecraft.banner.globe.pink": "Pink Globe",
  "block.minecraft.banner.globe.purple": "Purple Globe",
  "block.minecraft.banner.globe.red": "Red Globe",
  "block.minecraft.banner.globe.white": "White Globe",
  "block.minecraft.banner.globe.yellow": "Jaale Globe",
  "block.minecraft.banner.gradient.black": "Madow Gradient",
  "block.minecraft.banner.gradient.blue": "Gradient buluug",
  "block.minecraft.banner.gradient.brown": "Brown Gradient",
  "block.minecraft.banner.gradient.cyan": "Cyan Gradient",
  "block.minecraft.banner.gradient.gray": "Grey Gradient",
  "block.minecraft.banner.gradient.green": "Gradient cagaaran",
  "block.minecraft.banner.gradient.light_blue": "Gradient buluug khafiif ah",
  "block.minecraft.banner.gradient.light_gray": "Gradient Fudud",
  "block.minecraft.banner.gradient.lime": "Lime Gradient",
  "block.minecraft.banner.gradient.magenta": "Magenta Gradient",
  "block.minecraft.banner.gradient.orange": "Orange Gradient",
  "block.minecraft.banner.gradient.pink": "Pink Gradient",
  "block.minecraft.banner.gradient.purple": "Gradient Purple",
  "block.minecraft.banner.gradient.red": "Gradient Cas",
  "block.minecraft.banner.gradient.white": "Isjiidjiid caddaan",
  "block.minecraft.banner.gradient.yellow": "Jaalle Base Gradient",
  "block.minecraft.banner.gradient_up.black": "Madaw Base Gradient",
  "block.minecraft.banner.gradient_up.blue": "Gradient Saldhig buluug",
  "block.minecraft.banner.gradient_up.brown": "Gradient Saldhig Brown",
  "block.minecraft.banner.gradient_up.cyan": "Cyan Base Gradient",
  "block.minecraft.banner.gradient_up.gray": "Grey Base Gradient",
  "block.minecraft.banner.gradient_up.green": "Gradient Salka Cagaaran",
  "block.minecraft.banner.gradient_up.light_blue": "Saldhig buluug khafiif ah",
  "block.minecraft.banner.gradient_up.light_gray": "Gradient Saldhig Fudud",
  "block.minecraft.banner.gradient_up.lime": "Salka Lime Gradient",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Dabaqa Hoose",
  "block.minecraft.banner.gradient_up.orange": "Jaranjarada Saldhigga Orange",
  "block.minecraft.banner.gradient_up.pink": "Dhererka Saldhigga Pink",
  "block.minecraft.banner.gradient_up.purple": "Gradient Salka Purple",
  "block.minecraft.banner.gradient_up.red": "Dabaqa Cas ee Saldhigga Cas",
  "block.minecraft.banner.gradient_up.white": "Garawsanaanta Saldhigga Cad",
  "block.minecraft.banner.gradient_up.yellow": "Jaalle Base Gradient",
  "block.minecraft.banner.guster.black": "Guster Madow",
  "block.minecraft.banner.guster.blue": "Guster Buluug",
  "block.minecraft.banner.guster.brown": "Guster Bunni",
  "block.minecraft.banner.guster.cyan": "Guster Cyan",
  "block.minecraft.banner.guster.gray": "Guster Cawlan",
  "block.minecraft.banner.guster.green": "Guster Cagaaran",
  "block.minecraft.banner.guster.light_blue": "Iftiin Buluuga Guster",
  "block.minecraft.banner.guster.light_gray": "Iftiinka Gray Guster",
  "block.minecraft.banner.guster.lime": "Guster Lime",
  "block.minecraft.banner.guster.magenta": "Guster Magenta",
  "block.minecraft.banner.guster.orange": "Guster Oranji",
  "block.minecraft.banner.guster.pink": "Gunter Casaan",
  "block.minecraft.banner.guster.purple": "Guster Guduudan",
  "block.minecraft.banner.guster.red": "Gunter Casaan",
  "block.minecraft.banner.guster.white": "Gunter Caddaan",
  "block.minecraft.banner.guster.yellow": "Gunter Jaalle",
  "block.minecraft.banner.half_horizontal.black": "Madow halkii fess",
  "block.minecraft.banner.half_horizontal.blue": "Buluugga Per Fess",
  "block.minecraft.banner.half_horizontal.brown": "Brown halkii fess or  Brown Per Fess",
  "block.minecraft.banner.half_horizontal.cyan": "Cyan Per Fess",
  "block.minecraft.banner.half_horizontal.gray": "Gray Per Fess",
  "block.minecraft.banner.half_horizontal.green": "or Cagaar Per Fess",
  "block.minecraft.banner.half_horizontal.light_blue": "Buluug khafiif ah halkii Fess",
  "block.minecraft.banner.half_horizontal.light_gray": "Cawlan Fudud Per Fess",
  "block.minecraft.banner.half_horizontal.lime": "Lime Per Fess\n",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta Per Fess",
  "block.minecraft.banner.half_horizontal.orange": "Liimi Per Fes",
  "block.minecraft.banner.half_horizontal.pink": "Pink Per Fess",
  "block.minecraft.banner.half_horizontal.purple": "Carwaajis Per Fes",
  "block.minecraft.banner.half_horizontal.red": "Or Casaan Per Fess",
  "block.minecraft.banner.half_horizontal.white": "Caddaan Per Fes",
  "block.minecraft.banner.half_horizontal.yellow": "Jaalle Per Fess",
  "block.minecraft.banner.half_horizontal_bottom.black": "Madow Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Madow Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Akhtar Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyan Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Akhtar Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.green": "Akhtar Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Iftiin Buluug Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Iftiin Dameeri Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Madow Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Liimi Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Basali Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Carwaajis Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.red": "Casaan Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.white": "Madow Per Bend Soo Jeestay",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Jaalle Per Bend Soo Jeestay",
  "block.minecraft.banner.half_vertical.black": "Madaw halkii cirro",
  "block.minecraft.banner.half_vertical.blue": "Buluug Per cirro",
  "block.minecraft.banner.half_vertical.brown": "Bunni Per cirro",
  "block.minecraft.banner.half_vertical.cyan": "Cyan Per Pale",
  "block.minecraft.banner.half_vertical.gray": "Gray Per cirro",
  "block.minecraft.banner.half_vertical.green": "Cagaar halkii cirro",
  "block.minecraft.banner.half_vertical.light_blue": "Buluug khafiif ah halkii cirro",
  "block.minecraft.banner.half_vertical.light_gray": "Cawlan khafiif ah Per Pale",
  "block.minecraft.banner.half_vertical.lime": "Lime Per cirro",
  "block.minecraft.banner.half_vertical.magenta": "Magenta Per cirro",
  "block.minecraft.banner.half_vertical.orange": "Orange halkii cirro",
  "block.minecraft.banner.half_vertical.pink": "Pink Perle",
  "block.minecraft.banner.half_vertical.purple": "Guduudan Per cirro",
  "block.minecraft.banner.half_vertical.red": "Casaan halkii cirro",
  "block.minecraft.banner.half_vertical.white": "Cadaan halkii cirro",
  "block.minecraft.banner.half_vertical.yellow": "Jaalle halkii cirro",
  "block.minecraft.banner.half_vertical_right.black": "Madow halkii cirro ayaa leexday",
  "block.minecraft.banner.half_vertical_right.blue": "Buluugga halkii cirro ayaa leexday",
  "block.minecraft.banner.half_vertical_right.brown": "Brown halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyan Per cirro rogan",
  "block.minecraft.banner.half_vertical_right.gray": "Grey halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.green": "Cagaar halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.light_blue": "Cawlan Buluug ah halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.light_gray": "Cawlan Grey ah halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.lime": "Lime halkii cirro ayaa leexday",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta Per Bend Soo Jeestay",
  "block.minecraft.banner.half_vertical_right.orange": "Liimi halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.pink": "Casaan halkii cirro ayaa leexday",
  "block.minecraft.banner.half_vertical_right.purple": "Carwaajis halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.red": "Casaan halkii cirro ayaa rogtay",
  "block.minecraft.banner.half_vertical_right.white": "Caddaan Per Bend Soo Jeestay",
  "block.minecraft.banner.half_vertical_right.yellow": "Jaalle halkii cirro ayaa rogtay",
  "block.minecraft.banner.mojang.black": "Madow Shay",
  "block.minecraft.banner.mojang.blue": "Buluug Shay",
  "block.minecraft.banner.mojang.brown": "Bunni Shay",
  "block.minecraft.banner.mojang.cyan": "Cyan Shay",
  "block.minecraft.banner.mojang.gray": "Grey Shay",
  "block.minecraft.banner.mojang.green": "Cagaar Shay",
  "block.minecraft.banner.mojang.light_blue": "Madax buluug Shay",
  "block.minecraft.banner.mojang.light_gray": "Madax Grey Shay",
  "block.minecraft.banner.mojang.lime": "Lime Shay",
  "block.minecraft.banner.mojang.magenta": "Magenta Shay",
  "block.minecraft.banner.mojang.orange": "Oranji Shay",
  "block.minecraft.banner.mojang.pink": "Casaan Shay",
  "block.minecraft.banner.mojang.purple": "Guduudan Shay",
  "block.minecraft.banner.mojang.red": "Casaan Shay",
  "block.minecraft.banner.mojang.white": "Shay Cad",
  "block.minecraft.banner.mojang.yellow": "Shayga Jaallaha ah",
  "block.minecraft.banner.piglin.black": "Cunto madow",
  "block.minecraft.banner.piglin.blue": "Cunto buluug",
  "block.minecraft.banner.piglin.brown": "Cunto bunni",
  "block.minecraft.banner.piglin.cyan": "Cunto Baxri",
  "block.minecraft.banner.piglin.gray": "Cunto Cowl",
  "block.minecraft.banner.piglin.green": "Cunto cagaaran",
  "block.minecraft.banner.piglin.light_blue": "Cunto Buluug Iftiin",
  "block.minecraft.banner.piglin.light_gray": "Cunto Cowl Iftiin",
  "block.minecraft.banner.piglin.lime": "Cunto liin",
  "block.minecraft.banner.piglin.magenta": "Cunto Basli",
  "block.minecraft.banner.piglin.orange": "Cunto oranji",
  "block.minecraft.banner.piglin.pink": "Cunto casaan",
  "block.minecraft.banner.piglin.purple": "Cunto Guduud",
  "block.minecraft.banner.piglin.red": "Cunto casaan",
  "block.minecraft.banner.piglin.white": "Cunto cad",
  "block.minecraft.banner.piglin.yellow": "Cunto Jaale",
  "block.minecraft.banner.rhombus.black": "Lozenge Madoow",
  "block.minecraft.banner.rhombus.blue": "Buluug Lozenge",
  "block.minecraft.banner.rhombus.brown": "Bunni Lozenge",
  "block.minecraft.banner.rhombus.cyan": "Cyan Lozenge",
  "block.minecraft.banner.rhombus.gray": "Cawlan Lozenge",
  "block.minecraft.banner.rhombus.green": "Cagaaran Lozenge",
  "block.minecraft.banner.rhombus.light_blue": "Buluug khafiif ah Lozenge",
  "block.minecraft.banner.rhombus.light_gray": "Cawlan khafiif ah Lozenge",
  "block.minecraft.banner.rhombus.lime": "Lime Lozenge",
  "block.minecraft.banner.rhombus.magenta": "Magenta Lozenge",
  "block.minecraft.banner.rhombus.orange": "Oranji Lozenge",
  "block.minecraft.banner.rhombus.pink": "Casaan Lozenge",
  "block.minecraft.banner.rhombus.purple": "Guduudan Lozenge",
  "block.minecraft.banner.rhombus.red": "Lozenge Cas",
  "block.minecraft.banner.rhombus.white": "Caddaan Lozenge",
  "block.minecraft.banner.rhombus.yellow": "Jaalle Lozenge",
  "block.minecraft.banner.skull.black": "Kharash Madoow",
  "block.minecraft.banner.skull.blue": "Kharashka Qalfoofka Buluugga ah",
  "block.minecraft.banner.skull.brown": "Kharashka Dhafoofka Brown",
  "block.minecraft.banner.skull.cyan": "Cyan Skull Charge",
  "block.minecraft.banner.skull.gray": "Kharashka Qalfoofka Cawlan",
  "block.minecraft.banner.skull.green": "Kharashka Dhafoofka Cagaaran",
  "block.minecraft.banner.skull.light_blue": "Kharashka Dhafoofka Buluugga ah",
  "block.minecraft.banner.skull.light_gray": "Kharashka Qalfoofka Cawlan ee Fudud",
  "block.minecraft.banner.skull.lime": "Lacagta Dhafoorka Lime",
  "block.minecraft.banner.skull.magenta": "Magenta Skull Charge",
  "block.minecraft.banner.skull.orange": "Kharashka Dhafoorka Orange",
  "block.minecraft.banner.skull.pink": "Kharashka Qoorta Qoorta",
  "block.minecraft.banner.skull.purple": "Lacagta Dhafoorka Purple",
  "block.minecraft.banner.skull.red": "Kharashka Dhafoorka Cas",
  "block.minecraft.banner.skull.white": "Lacagta Dhafoofka Cad",
  "block.minecraft.banner.skull.yellow": "Lacagta Dhafoorka Jaallaha ah",
  "block.minecraft.banner.small_stripes.black": "Madow Khadadka Yar",
  "block.minecraft.banner.small_stripes.blue": "Buluug Khadadka Yar",
  "block.minecraft.banner.small_stripes.brown": "Bunni Khadadka Yar",
  "block.minecraft.banner.small_stripes.cyan": "Cyan Khadadka Yar",
  "block.minecraft.banner.small_stripes.gray": "Dameeri Khadadka Yar",
  "block.minecraft.banner.small_stripes.green": "Akhtar Khadadka Yar",
  "block.minecraft.banner.small_stripes.light_blue": "Iftiin Buluug Khadadka Yar",
  "block.minecraft.banner.small_stripes.light_gray": "Iftiin Dameeri Khadadka Yar",
  "block.minecraft.banner.small_stripes.lime": "Lime Khadadka Yar",
  "block.minecraft.banner.small_stripes.magenta": "Magenta Khadadka Yar",
  "block.minecraft.banner.small_stripes.orange": "Liimi Khadadka Yar",
  "block.minecraft.banner.small_stripes.pink": "Basali Khadadka Yar",
  "block.minecraft.banner.small_stripes.purple": "Carwaajis Khadadka Yar",
  "block.minecraft.banner.small_stripes.red": "Casaan Khadadka Yar",
  "block.minecraft.banner.small_stripes.white": "Caddaan Khadadka Yar",
  "block.minecraft.banner.small_stripes.yellow": "Jaalle Khadadka Yar",
  "block.minecraft.banner.square_bottom_left.black": "Kanton saldhiga madow ee dexter",
  "block.minecraft.banner.square_bottom_left.blue": "Saldhig Buluugga Dexter Canton",
  "block.minecraft.banner.square_bottom_left.brown": "Saldhig Brown Dexter Canton",
  "block.minecraft.banner.square_bottom_left.cyan": "Saldhig Cyan Dexter Canton",
  "block.minecraft.banner.square_bottom_left.gray": "Saldhigga Gray Dexter Canton",
  "block.minecraft.banner.square_bottom_left.green": "Saldhigga Cagaaran Dexter Canton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Saldhig Buluug khafiif ah Dexter Canton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Saldhigga Cawlan fudud ee Dexter Canton",
  "block.minecraft.banner.square_bottom_left.lime": "Saldhig Lime Dexter Canton",
  "block.minecraft.banner.square_bottom_left.magenta": "Saldhig Magenta Dexter Canton",
  "block.minecraft.banner.square_bottom_left.orange": "Orange saldhigga Dexter Canton",
  "block.minecraft.banner.square_bottom_left.pink": "Pink saldhigga Dexter Canton",
  "block.minecraft.banner.square_bottom_left.purple": "Saldhigga guduudan ee Dexter Canton",
  "block.minecraft.banner.square_bottom_left.red": "Saldhigga Cas ee Dexter Canton",
  "block.minecraft.banner.square_bottom_left.white": "Saldhigga Cad ee Dexter Canton",
  "block.minecraft.banner.square_bottom_left.yellow": "Saldhig Jaalle Dexter Canton",
  "block.minecraft.banner.square_bottom_right.black": "Saldhig Madow Sinister Canton",
  "block.minecraft.banner.square_bottom_right.blue": "Saldhigga buluuga ah ee Sinister Canton",
  "block.minecraft.banner.square_bottom_right.brown": "Brown Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyan Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.gray": "Saldhiga Cawl Sinister Canton",
  "block.minecraft.banner.square_bottom_right.green": "Saldhigga Cagaaran Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Saldhig Buluug khafiif ah Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Saldhigga Cawlan ee Fudud ee Sinister Canton",
  "block.minecraft.banner.square_bottom_right.lime": "Saldhig Lime Sinister Canton",
  "block.minecraft.banner.square_bottom_right.magenta": "Saldhig Magenta Sinister Canton",
  "block.minecraft.banner.square_bottom_right.orange": "Saldhig orange Sinister Canton",
  "block.minecraft.banner.square_bottom_right.pink": "Saldhig Pink Sinister Canton",
  "block.minecraft.banner.square_bottom_right.purple": "Base guduudka ah Sinister Canton",
  "block.minecraft.banner.square_bottom_right.red": "Saldhigga Cas Sinister Canton",
  "block.minecraft.banner.square_bottom_right.white": "Saldhiga Cad ee Sinister Canton",
  "block.minecraft.banner.square_bottom_right.yellow": "Saldhig Jaalle Sinister Canton",
  "block.minecraft.banner.square_top_left.black": "Madaxa Madow Dexter Canton",
  "block.minecraft.banner.square_top_left.blue": "Hogaamiyaha Buluuga Ah Dexter Canton",
  "block.minecraft.banner.square_top_left.brown": "Hogaamiyaha Bunni Ah Dexter Canton",
  "block.minecraft.banner.square_top_left.cyan": "Hogaamiyaha Cyan Dexter Canton",
  "block.minecraft.banner.square_top_left.gray": "Hogaamiyaha Cawlan Dexter Canton",
  "block.minecraft.banner.square_top_left.green": "Hogaamiyaha Cagaaran Dexter Canton",
  "block.minecraft.banner.square_top_left.light_blue": "Hogaamiye Buluug Khafiif Ah Dexter Canton",
  "block.minecraft.banner.square_top_left.light_gray": "Hogaamiye cawl khafiif ah Dexter Canton",
  "block.minecraft.banner.square_top_left.lime": "Hogaamiyaha Lime Dexter Canton",
  "block.minecraft.banner.square_top_left.magenta": "Hogaamiyaha Magenta Dexter Canton",
  "block.minecraft.banner.square_top_left.orange": "Hogaamiyaha Oranji Dexter Canton",
  "block.minecraft.banner.square_top_left.pink": "Hogaamiyaha Basali Dexter Canton",
  "block.minecraft.banner.square_top_left.purple": "Lila Hogaamiyaha Dexter Canton",
  "block.minecraft.banner.square_top_left.red": "Hogaamiyaha Cas Dexter Canton",
  "block.minecraft.banner.square_top_left.white": "Hogaamiyaha Cadaanka Dexter Canton",
  "block.minecraft.banner.square_top_left.yellow": "Hogaamiyaha Jaallaha Dexter Canton",
  "block.minecraft.banner.square_top_right.black": "Hogaamiyaha Madow Sinister Canton",
  "block.minecraft.banner.square_top_right.blue": "Hogaamiyaha buluuga Sinister Canton",
  "block.minecraft.banner.square_top_right.brown": "Hogaamiyaha Bunni Sinister Canton",
  "block.minecraft.banner.square_top_right.cyan": "Hogaamiyaha Cyan Sinister Canton",
  "block.minecraft.banner.square_top_right.gray": "Hogaamiyaha Dameeri Sinister Canton",
  "block.minecraft.banner.square_top_right.green": "Hogaamiyaha Cagaaran Sinister Canton",
  "block.minecraft.banner.square_top_right.light_blue": "Hogaamiyaha Buluug Khafiif Sinister Canton",
  "block.minecraft.banner.square_top_right.light_gray": "Hogaamiyaha cawl khafiif Dexter Canton",
  "block.minecraft.banner.square_top_right.lime": "Hogaamiyaha Lime Sinister Canton",
  "block.minecraft.banner.square_top_right.magenta": "Hogaamiyaha Magenta Sinister Canton",
  "block.minecraft.banner.square_top_right.orange": "Hogaamiyaha Liimi Ah Sinister Canton",
  "block.minecraft.banner.square_top_right.pink": "Hogaamiyaha Basali Sinister Canton",
  "block.minecraft.banner.square_top_right.purple": "Hogaamiyaha Carwaajis Sinister Canton",
  "block.minecraft.banner.square_top_right.red": "Hogaamiyaha Cas Sinister Canton",
  "block.minecraft.banner.square_top_right.white": "Caddaan caaqil xumaan kanton",
  "block.minecraft.banner.square_top_right.yellow": "Hogaamiyaha Jaale Sinister Canton",
  "block.minecraft.banner.straight_cross.black": "Black Cross",
  "block.minecraft.banner.straight_cross.blue": "Buluugga Cross",
  "block.minecraft.banner.straight_cross.brown": "Brown Cross",
  "block.minecraft.banner.straight_cross.cyan": "Cyan Cross",
  "block.minecraft.banner.straight_cross.gray": "Grey Cross",
  "block.minecraft.banner.straight_cross.green": "Green Cross",
  "block.minecraft.banner.straight_cross.light_blue": "Iskutallaab buluug khafiif ah",
  "block.minecraft.banner.straight_cross.light_gray": "Cross Gray Light",
  "block.minecraft.banner.straight_cross.lime": "Lime Cross",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Cross",
  "block.minecraft.banner.straight_cross.orange": "Orange Cross",
  "block.minecraft.banner.straight_cross.pink": "Pink Cross",
  "block.minecraft.banner.straight_cross.purple": "Gudub Purple",
  "block.minecraft.banner.straight_cross.red": "Laanqayrta Cas",
  "block.minecraft.banner.straight_cross.white": "Iskutallaab cad",
  "block.minecraft.banner.straight_cross.yellow": "Jaalle Cross",
  "block.minecraft.banner.stripe_bottom.black": "Saldhig madow",
  "block.minecraft.banner.stripe_bottom.blue": "Buluug saldhig",
  "block.minecraft.banner.stripe_bottom.brown": "Saldhig bunni",
  "block.minecraft.banner.stripe_bottom.cyan": "Saldhig cyan",
  "block.minecraft.banner.stripe_bottom.gray": "Saldhig cawlan",
  "block.minecraft.banner.stripe_bottom.green": "Cagaar saldhig",
  "block.minecraft.banner.stripe_bottom.light_blue": "Saldhig buluug khafiif ah",
  "block.minecraft.banner.stripe_bottom.light_gray": "Saldhig cawl khafiif ah",
  "block.minecraft.banner.stripe_bottom.lime": "Saldhig lime",
  "block.minecraft.banner.stripe_bottom.magenta": "Saldhig fuchsia",
  "block.minecraft.banner.stripe_bottom.orange": "Oranji saldhig",
  "block.minecraft.banner.stripe_bottom.pink": "Saldhig pink",
  "block.minecraft.banner.stripe_bottom.purple": "Saldhig guduudan",
  "block.minecraft.banner.stripe_bottom.red": "Saldhig casaan",
  "block.minecraft.banner.stripe_bottom.white": "Caddaan saldhig",
  "block.minecraft.banner.stripe_bottom.yellow": "Saldhig jaale",
  "block.minecraft.banner.stripe_center.black": "Cirro Madow",
  "block.minecraft.banner.stripe_center.blue": "Cirro Buluug",
  "block.minecraft.banner.stripe_center.brown": "Cirro Bunni",
  "block.minecraft.banner.stripe_center.cyan": "Cirro Cyan",
  "block.minecraft.banner.stripe_center.gray": "Cirro Dameeri",
  "block.minecraft.banner.stripe_center.green": "Cirro Akhtar",
  "block.minecraft.banner.stripe_center.light_blue": "Cirro Iftiin Buluug",
  "block.minecraft.banner.stripe_center.light_gray": "Cirro Iftiin Dameeri",
  "block.minecraft.banner.stripe_center.lime": "Cirro Lime",
  "block.minecraft.banner.stripe_center.magenta": "Cirro Magenta",
  "block.minecraft.banner.stripe_center.orange": "Cirro Limii",
  "block.minecraft.banner.stripe_center.pink": "Cirro Basali",
  "block.minecraft.banner.stripe_center.purple": "Cirro Carwaajis",
  "block.minecraft.banner.stripe_center.red": "Cirro Casaan",
  "block.minecraft.banner.stripe_center.white": "Cirro Casaan",
  "block.minecraft.banner.stripe_center.yellow": "Cirro Jaalle",
  "block.minecraft.banner.stripe_downleft.black": "Madow Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.blue": "Buluug Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.brown": "Bunni Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyan Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.gray": "Dameeri Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.green": "Cagaar Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.light_blue": "Iftiin Buluug Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.light_gray": "Iftiin Dameeri Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.lime": "Lime Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.orange": "Liimi Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.pink": "Basali Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.purple": "Carwaajis Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.red": "Casaan Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.white": "Caddaan Geesal-Bidix",
  "block.minecraft.banner.stripe_downleft.yellow": "Jaalle Geesal-Bidix",
  "block.minecraft.banner.stripe_downright.black": "Madow Geesal-Xaq",
  "block.minecraft.banner.stripe_downright.blue": "Leexsan buluug",
  "block.minecraft.banner.stripe_downright.brown": "Leexsan bunni",
  "block.minecraft.banner.stripe_downright.cyan": "Qaloocin cyan",
  "block.minecraft.banner.stripe_downright.gray": "Qalooci cawl",
  "block.minecraft.banner.stripe_downright.green": "Cagaar Geesal-Xaq",
  "block.minecraft.banner.stripe_downright.light_blue": "Leexsan buluug khafiif ah",
  "block.minecraft.banner.stripe_downright.light_gray": "Qalooci cawl khafiif ah",
  "block.minecraft.banner.stripe_downright.lime": "Lime laablaabid",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Geesal-Xaq",
  "block.minecraft.banner.stripe_downright.orange": "Liimi Geesal-Xaq",
  "block.minecraft.banner.stripe_downright.pink": "Qalooci casaan",
  "block.minecraft.banner.stripe_downright.purple": "Laalaab guduudan",
  "block.minecraft.banner.stripe_downright.red": "Casaan Geesal-Xaq",
  "block.minecraft.banner.stripe_downright.white": "Caddaan Geesal-Xaq",
  "block.minecraft.banner.stripe_downright.yellow": "Jaalle leexsan",
  "block.minecraft.banner.stripe_left.black": "Cirro madow",
  "block.minecraft.banner.stripe_left.blue": "Midab buluug ah oo buluug ah",
  "block.minecraft.banner.stripe_left.brown": "Cirro bunni dexter",
  "block.minecraft.banner.stripe_left.cyan": "Cyan cirro dexter",
  "block.minecraft.banner.stripe_left.gray": "Dexter cirro cawl",
  "block.minecraft.banner.stripe_left.green": "Cirro cagaar ah",
  "block.minecraft.banner.stripe_left.light_blue": "Qalab buluug khafiif ah oo cirro leh",
  "block.minecraft.banner.stripe_left.light_gray": "Dexter cirro cawl khafiif ah",
  "block.minecraft.banner.stripe_left.lime": "Lime cirro leh",
  "block.minecraft.banner.stripe_left.magenta": "Magenta cirro leh",
  "block.minecraft.banner.stripe_left.orange": "Midab liimi ah",
  "block.minecraft.banner.stripe_left.pink": "Midab casaan ah oo cirro leh",
  "block.minecraft.banner.stripe_left.purple": "Cawl cirro leh",
  "block.minecraft.banner.stripe_left.red": "Cirro guduudan",
  "block.minecraft.banner.stripe_left.white": "Dhaqaale cirro cad",
  "block.minecraft.banner.stripe_left.yellow": "Midab huruud ah",
  "block.minecraft.banner.stripe_middle.black": "Madow khadka dhexe",
  "block.minecraft.banner.stripe_middle.blue": "Buluug Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.brown": "Bunni khadka dhexe",
  "block.minecraft.banner.stripe_middle.cyan": "Cyan Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.gray": "Dameeri Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.green": "Cagaar khadka dhexe",
  "block.minecraft.banner.stripe_middle.light_blue": "Iftiin Buluug Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.light_gray": "Iftiin Dameeri Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.lime": "Lime Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.orange": "Liimi Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.pink": "Basali Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.purple": "Carwaajis Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.red": "Casaan khadka dhexe",
  "block.minecraft.banner.stripe_middle.white": "Caddaan Khadka Dhexe",
  "block.minecraft.banner.stripe_middle.yellow": "Jaalle Khadka Dhexe",
  "block.minecraft.banner.stripe_right.black": "Xumaan madow cirro",
  "block.minecraft.banner.stripe_right.blue": "Xumaanta Cirro Buluuga ah",
  "block.minecraft.banner.stripe_right.brown": "Bunni Cirro Dembiilayaal",
  "block.minecraft.banner.stripe_right.cyan": "Cirro Cyan Sinister",
  "block.minecraft.banner.stripe_right.gray": "Cirro Dameeri Sinister",
  "block.minecraft.banner.stripe_right.green": "Cagaar Ciro Xun",
  "block.minecraft.banner.stripe_right.light_blue": "Cirro Buluug Khafiif Ah Sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Cirro Cawlan Khafiif Ah Sinister",
  "block.minecraft.banner.stripe_right.lime": "Cirro Lime Sinister",
  "block.minecraft.banner.stripe_right.magenta": "Cirro Magenta Sinister",
  "block.minecraft.banner.stripe_right.orange": "Cirro Liimi Sinister",
  "block.minecraft.banner.stripe_right.pink": "Cirro Basali Sinister",
  "block.minecraft.banner.stripe_right.purple": "Cirro Carwaajis Sinister",
  "block.minecraft.banner.stripe_right.red": "Xumaanta Cirro Cas",
  "block.minecraft.banner.stripe_right.white": "Cirro Caddaan Sinister",
  "block.minecraft.banner.stripe_right.yellow": "Jaalle Cirro Sinister",
  "block.minecraft.banner.stripe_top.black": "Madax madow",
  "block.minecraft.banner.stripe_top.blue": "Madax buluug",
  "block.minecraft.banner.stripe_top.brown": "Madax bunni",
  "block.minecraft.banner.stripe_top.cyan": "Madax cyan",
  "block.minecraft.banner.stripe_top.gray": "Madmax cawlan",
  "block.minecraft.banner.stripe_top.green": "Madax cagaar",
  "block.minecraft.banner.stripe_top.light_blue": "Madax buluug khafiif ah",
  "block.minecraft.banner.stripe_top.light_gray": "Madax cawlan khafiif ah",
  "block.minecraft.banner.stripe_top.lime": "Madmax lime",
  "block.minecraft.banner.stripe_top.magenta": "Madmax magenta",
  "block.minecraft.banner.stripe_top.orange": "Madmax oranji",
  "block.minecraft.banner.stripe_top.pink": "Madmax casaan",
  "block.minecraft.banner.stripe_top.purple": "Madax guduudan",
  "block.minecraft.banner.stripe_top.red": "Madax cas",
  "block.minecraft.banner.stripe_top.white": "Madmax caddaan",
  "block.minecraft.banner.stripe_top.yellow": "Madmax jaale",
  "block.minecraft.banner.triangle_bottom.black": "Madow Saddex xagal",
  "block.minecraft.banner.triangle_bottom.blue": "Buluug Saddex xagal",
  "block.minecraft.banner.triangle_bottom.brown": "Bunni Saddex xagal",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyan Saddex xagal",
  "block.minecraft.banner.triangle_bottom.gray": "Dameeri Saddex xagal",
  "block.minecraft.banner.triangle_bottom.green": "Akhtar Saddex xagal",
  "block.minecraft.banner.triangle_bottom.light_blue": "Iftiin Buluug Saddex xagal",
  "block.minecraft.banner.triangle_bottom.light_gray": "Iftiin Dameeri Saddex xagal",
  "block.minecraft.banner.triangle_bottom.lime": "Lime Saddex xagal",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta Saddex xagal",
  "block.minecraft.banner.triangle_bottom.orange": "Liimi Saddex xagal",
  "block.minecraft.banner.triangle_bottom.pink": "Basali",
  "block.minecraft.banner.triangle_bottom.purple": "Carwaajis Saddex xagal",
  "block.minecraft.banner.triangle_bottom.red": "Casaan Saddex xagal",
  "block.minecraft.banner.triangle_bottom.white": "Caddaan Saddex xagal",
  "block.minecraft.banner.triangle_bottom.yellow": "Jaalle Saddex xagal",
  "block.minecraft.banner.triangle_top.black": "Madow Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.blue": "Buluug Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.brown": "Bunni Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.cyan": "Cyan Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.gray": "Dameeri Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.green": "Akhtar Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.light_blue": "Iftiin Buluug Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.light_gray": "Iftiin Dameeri Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.lime": "Lime Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.magenta": "Magenta Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.orange": "Liimi Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.pink": "Basali Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.purple": "Carwaajis Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.red": "Casaan Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.white": "Caddaan Saddex Xagal Foorari",
  "block.minecraft.banner.triangle_top.yellow": "Jaalle Saddex Xagal Foorari",
  "block.minecraft.banner.triangles_bottom.black": "Madow Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.blue": "Buluug Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.brown": "Bunni Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyan Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.gray": "Dameeri Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.green": "Akhtar Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.light_blue": "Iftiin Buluug Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.light_gray": "Iftiin Dameeri Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.lime": "Lime Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.orange": "Liimi Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.pink": "Basali Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.purple": "Carwaajis Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.red": "Casaan Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.white": "Caddaan Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_bottom.yellow": "Jaalle Hirarka Aasaasiga",
  "block.minecraft.banner.triangles_top.black": "Madow Foorari Mawjad",
  "block.minecraft.banner.triangles_top.blue": "Buluug Foorari Mawjad",
  "block.minecraft.banner.triangles_top.brown": "Bunni Foorari Mawjad",
  "block.minecraft.banner.triangles_top.cyan": "Cyan Foorari Mawjad",
  "block.minecraft.banner.triangles_top.gray": "Dameeri Foorari Mawjad",
  "block.minecraft.banner.triangles_top.green": "Akhtar Foorari Mawjad",
  "block.minecraft.banner.triangles_top.light_blue": "Iftiin Buluug Foorari Mawjad",
  "block.minecraft.banner.triangles_top.light_gray": "Iftiin Dameeri Foorari Mawjad",
  "block.minecraft.banner.triangles_top.lime": "Lime Foorari Mawjad",
  "block.minecraft.banner.triangles_top.magenta": "Magenta Foorari Mawjad",
  "block.minecraft.banner.triangles_top.orange": "Liimi Foorari Mawjad",
  "block.minecraft.banner.triangles_top.pink": "Basali Foorari Mawjad",
  "block.minecraft.banner.triangles_top.purple": "Carwaajis Foorari Mawjad",
  "block.minecraft.banner.triangles_top.red": "Casaan Foorari Mawjad",
  "block.minecraft.banner.triangles_top.white": "Caddaan Foorari Mawjad",
  "block.minecraft.banner.triangles_top.yellow": "Jaalle Foorari Mawjad",
  "block.minecraft.barrel": "Foosto",
  "block.minecraft.barrier": "Ooday",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Iftiinka",
  "block.minecraft.beacon.primary": "Awood Kowaad",
  "block.minecraft.beacon.secondary": "Awood Lawaad",
  "block.minecraft.bed.no_sleep": "You can sleep only at night or during thunderstorms",
  "block.minecraft.bed.not_safe": "Waxa laga yaabaa inaadan nasan hadda; waxaa jira daanyeero u dhow",
  "block.minecraft.bed.obstructed": "Sariirtani waa mid xanniban",
  "block.minecraft.bed.occupied": "Sariirtan ayaa lagu dhexjiray",
  "block.minecraft.bed.too_far_away": "Waxa laga yaabaa inaadan nasan hadda; sariirtu aad ayey uga fog tahay",
  "block.minecraft.bedrock": "Bedrock",
  "block.minecraft.bee_nest": "Bee Nest",
  "block.minecraft.beehive": "Guri shinni",
  "block.minecraft.beetroots": "Bahalto",
  "block.minecraft.bell": "Jal",
  "block.minecraft.big_dripleaf": "Saxarka weyn",
  "block.minecraft.big_dripleaf_stem": "Shoppros weyn oo stem",
  "block.minecraft.birch_button": "Birch Button",
  "block.minecraft.birch_door": "Albaabka boodhka",
  "block.minecraft.birch_fence": "Birch Fence",
  "block.minecraft.birch_fence_gate": "Albaabka Birch Fence",
  "block.minecraft.birch_hanging_sign": "Calaamada Birch Laadlaadsan",
  "block.minecraft.birch_leaves": "Birch Leaves",
  "block.minecraft.birch_log": "Diiwaangelinta Birch",
  "block.minecraft.birch_planks": "Qorshaha Birch",
  "block.minecraft.birch_pressure_plate": "Cadaadiska Birch Cadaadiska",
  "block.minecraft.birch_sapling": "Birch Sapling",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Saxiix bjørk",
  "block.minecraft.birch_slab": "Bjørk Xargaha",
  "block.minecraft.birch_stairs": "Bjørk Jaranjaro",
  "block.minecraft.birch_trapdoor": "Birch Trapdoor",
  "block.minecraft.birch_wall_hanging_sign": "Calaamadda Darbiga Birch ee Laalaada",
  "block.minecraft.birch_wall_sign": "Bjørk derbiga saxiix",
  "block.minecraft.birch_wood": "Birch Wood",
  "block.minecraft.black_banner": "Calan Madow",
  "block.minecraft.black_bed": "Sariirta madow",
  "block.minecraft.black_candle": "Shumaca Madoow",
  "block.minecraft.black_candle_cake": "Keeg leh Shumaca Madoow",
  "block.minecraft.black_carpet": "Black kaarbadka",
  "block.minecraft.black_concrete": "Madow La Taaban Karo",
  "block.minecraft.black_concrete_powder": "Madow Budada La Taaban Karo",
  "block.minecraft.black_glazed_terracotta": "Madow Madxafka Terracotta",
  "block.minecraft.black_shulker_box": "Sanduuqa madow ee madow",
  "block.minecraft.black_stained_glass": "Black wasakheeyey Glass",
  "block.minecraft.black_stained_glass_pane": "Black wasakheeyey Murayaad",
  "block.minecraft.black_terracotta": "Black Terracotta",
  "block.minecraft.black_wool": "Wool madow",
  "block.minecraft.blackstone": "Blackstone",
  "block.minecraft.blackstone_slab": "Blackstone Slab",
  "block.minecraft.blackstone_stairs": "Blackstone Stairs",
  "block.minecraft.blackstone_wall": "Blackstone Wall",
  "block.minecraft.blast_furnace": "Foornada qarxa",
  "block.minecraft.blue_banner": "Calan Buluug Ah",
  "block.minecraft.blue_bed": "Sariirta Buluugga ah",
  "block.minecraft.blue_candle": "Shumaca Buluuga ah",
  "block.minecraft.blue_candle_cake": "Keeg Buluug Buluug ah",
  "block.minecraft.blue_carpet": "Blue kaarbadka",
  "block.minecraft.blue_concrete": "Buluug la taaban karo",
  "block.minecraft.blue_concrete_powder": "Buulug La taaban karo Budada",
  "block.minecraft.blue_glazed_terracotta": "Buluug glazed terracotta",
  "block.minecraft.blue_ice": "Blue Ice",
  "block.minecraft.blue_orchid": "Buluug ubax",
  "block.minecraft.blue_shulker_box": "Sanduuqa shalker buluug",
  "block.minecraft.blue_stained_glass": "Blue wasakheeyey Glass",
  "block.minecraft.blue_stained_glass_pane": "Blue wasakheeyey Murayaad",
  "block.minecraft.blue_terracotta": "Blue Terracotta",
  "block.minecraft.blue_wool": "Wool buluug ah",
  "block.minecraft.bone_block": "Laf Block",
  "block.minecraft.bookshelf": "Bookshelf",
  "block.minecraft.brain_coral": "Maskaxda corta",
  "block.minecraft.brain_coral_block": "Block Coral Block",
  "block.minecraft.brain_coral_fan": "Fanaanka Coral Maskaxda",
  "block.minecraft.brain_coral_wall_fan": "Taageeraha Darbiga Darbiga Maskaxda",
  "block.minecraft.brewing_stand": "Istaag taagan",
  "block.minecraft.brick_slab": "Lebbiska Xargaha",
  "block.minecraft.brick_stairs": "tallaabooyinka lebenka",
  "block.minecraft.brick_wall": "Derbiga lebbiska",
  "block.minecraft.bricks": "Bricks",
  "block.minecraft.brown_banner": "Calan Bunni Ah",
  "block.minecraft.brown_bed": "Sariirta Brown",
  "block.minecraft.brown_candle": "Shumaca buniga ah",
  "block.minecraft.brown_candle_cake": "Keeg leh Shumaca buniga ah",
  "block.minecraft.brown_carpet": "Brown kaarbadka",
  "block.minecraft.brown_concrete": "Bunni La Taaban Karo",
  "block.minecraft.brown_concrete_powder": "Bunni Budada La Taaban Karo",
  "block.minecraft.brown_glazed_terracotta": "Bunni Madxafka Terracotta",
  "block.minecraft.brown_mushroom": "Brown Mushroom",
  "block.minecraft.brown_mushroom_block": "Cube likaha kafee",
  "block.minecraft.brown_shulker_box": "Sanduuqa shaleefka bunni",
  "block.minecraft.brown_stained_glass": "Brown wasakheeyey Glass",
  "block.minecraft.brown_stained_glass_pane": "Brown wasakheeyey Murayaad",
  "block.minecraft.brown_terracotta": "Brown Terracotta",
  "block.minecraft.brown_wool": "Wool brown",
  "block.minecraft.bubble_column": "Tiirka Xumbo",
  "block.minecraft.bubble_coral": "Coral xumbo",
  "block.minecraft.bubble_coral_block": "Xumbo Coral Block",
  "block.minecraft.bubble_coral_fan": "8 Fan Xumbo Coral",
  "block.minecraft.bubble_coral_wall_fan": "Xumbo Taageeraha Darbiga Coral",
  "block.minecraft.budding_amethyst": "Ametida Budding",
  "block.minecraft.bush": "\tDhir yar",
  "block.minecraft.cactus": "Tiin",
  "block.minecraft.cactus_flower": "Ubax Cactus",
  "block.minecraft.cake": "Cake",
  "block.minecraft.calcite": "Calcite\n",
  "block.minecraft.calibrated_sculk_sensor": "Dareemiyaha Sculk Calibrated",
  "block.minecraft.campfire": "Xarada Dabkah",
  "block.minecraft.candle": "Shumac",
  "block.minecraft.candle_cake": "Cake Shumaca",
  "block.minecraft.carrots": "Karooto",
  "block.minecraft.cartography_table": "Miiska sawirka",
  "block.minecraft.carved_pumpkin": "Xaraash",
  "block.minecraft.cauldron": "kuleylka",
  "block.minecraft.cave_air": "Hawada qaboojinta",
  "block.minecraft.cave_vines": "Cawska godka",
  "block.minecraft.cave_vines_plant": "Goynta geedaha geedaha",
  "block.minecraft.chain": "Silsilad",
  "block.minecraft.chain_command_block": "Ku celcelinta leben amarka",
  "block.minecraft.cherry_button": "Button Cherry",
  "block.minecraft.cherry_door": "Cherry Door",
  "block.minecraft.cherry_fence": "Xayndaabka Cherry",
  "block.minecraft.cherry_fence_gate": "Cherry Fence Gate",
  "block.minecraft.cherry_hanging_sign": "Calaamadda Cherry Laadlaadda",
  "block.minecraft.cherry_leaves": "Caleenta Cherry",
  "block.minecraft.cherry_log": "Cherry Log",
  "block.minecraft.cherry_planks": "Cherry planks",
  "block.minecraft.cherry_pressure_plate": "Saxanka Cadaadiska Cherry",
  "block.minecraft.cherry_sapling": "Cherry Sapling",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Calaamadda Cherry",
  "block.minecraft.cherry_slab": "Cherry Slab",
  "block.minecraft.cherry_stairs": "Cherry jaranjarada",
  "block.minecraft.cherry_trapdoor": "Cherry Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Calaamadda gidaarka Cherry",
  "block.minecraft.cherry_wall_sign": "Calaamadda gidaarka Cherry",
  "block.minecraft.cherry_wood": "Cherry Wood",
  "block.minecraft.chest": "Chest",
  "block.minecraft.chipped_anvil": "Xanrunta jaban",
  "block.minecraft.chiseled_bookshelf": "Khaanad Buugaag la Xardhay",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "Qoto dheer dhagax jeexan",
  "block.minecraft.chiseled_nether_bricks": "Chiseled Nether Bricks",
  "block.minecraft.chiseled_polished_blackstone": "Chiseled Polished Blackstone",
  "block.minecraft.chiseled_quartz_block": "chiseled xannibaadda quarterz",
  "block.minecraft.chiseled_red_sandstone": "Qoray Red sandstone",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Qoray sandstone",
  "block.minecraft.chiseled_stone_bricks": "Lebenkii qoray Stone",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "Ubax Chorus",
  "block.minecraft.chorus_plant": "Warshad chorus",
  "block.minecraft.clay": "Clay",
  "block.minecraft.closed_eyeblossom": "Indho-xiran Ubax",
  "block.minecraft.coal_block": "Dhuxusha Dhuxusha",
  "block.minecraft.coal_ore": "Dhuxul Ore",
  "block.minecraft.coarse_dirt": "Stony ground",
  "block.minecraft.cobbled_deepslate": "Dhagaxyo qoto dheer",
  "block.minecraft.cobbled_deepslate_slab": "Qoto dheer dhagax saxan",
  "block.minecraft.cobbled_deepslate_stairs": "Qoto dheer dhagax jaranjaro",
  "block.minecraft.cobbled_deepslate_wall": "Qoto dheer dhagax derbi",
  "block.minecraft.cobblestone": "Cobblestone",
  "block.minecraft.cobblestone_slab": "Samysan bulukeeti",
  "block.minecraft.cobblestone_stairs": "Jaranjarooyinka Cobblestone",
  "block.minecraft.cobblestone_wall": "gidaarka dhagaxa ah",
  "block.minecraft.cobweb": "Cobweb",
  "block.minecraft.cocoa": "Cocoa",
  "block.minecraft.command_block": "Lebenkii amarka",
  "block.minecraft.comparator": "Is barbar dhig dhagax cas",
  "block.minecraft.composter": "Dib u warshadaynta",
  "block.minecraft.conduit": "Biyomareenka",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Block of Copper",
  "block.minecraft.copper_bulb": "Laambad Naxaas",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Albaabka Naxaas",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Shaashad Naxaas",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Macdanta naxaasta ah",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Miisaanka qulqulka",
  "block.minecraft.cracked_deepslate_bricks": "Lebenkii Deepslate ee dillaacay",
  "block.minecraft.cracked_deepslate_tiles": "Lebenkii Deepslate ee dillaacay",
  "block.minecraft.cracked_nether_bricks": "Cracked Nether Bricks",
  "block.minecraft.cracked_polished_blackstone_bricks": "Cracked Polished Blackstone Bricks",
  "block.minecraft.cracked_stone_bricks": "Lebenkii qoray Stone",
  "block.minecraft.crafter": "Farsamoyaqaan",
  "block.minecraft.crafting_table": "Crafting Table",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Madaxa Creeper",
  "block.minecraft.creeper_wall_head": "Madaxa derbiga derbiga",
  "block.minecraft.crimson_button": "Crimson Button",
  "block.minecraft.crimson_door": "Crimson Door",
  "block.minecraft.crimson_fence": "Crimson Fence",
  "block.minecraft.crimson_fence_gate": "Crimson Fence Gate",
  "block.minecraft.crimson_fungus": "Crimson Fungus",
  "block.minecraft.crimson_hanging_sign": "Crimson Hanging Sign",
  "block.minecraft.crimson_hyphae": "Crimson Hyphae",
  "block.minecraft.crimson_nylium": "Crimson Nylium",
  "block.minecraft.crimson_planks": "Crimson Planks",
  "block.minecraft.crimson_pressure_plate": "Crimson Pressure Plate",
  "block.minecraft.crimson_roots": "Xididdada gaduudka",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Calaamadda Cas",
  "block.minecraft.crimson_slab": "Crimson Slab",
  "block.minecraft.crimson_stairs": "Crimson Stairs",
  "block.minecraft.crimson_stem": "Crimson Stem",
  "block.minecraft.crimson_trapdoor": "Crimson Trapdoor",
  "block.minecraft.crimson_wall_hanging_sign": "Crimson Wall Hanging Sign",
  "block.minecraft.crimson_wall_sign": "Crimson calaamadda darbiga",
  "block.minecraft.crying_obsidian": "Crying Obsidian",
  "block.minecraft.cut_copper": "Jaro Maarta",
  "block.minecraft.cut_copper_slab": "Iska jar Naxaasta",
  "block.minecraft.cut_copper_stairs": "\nIska yaree Jaranjarada Maarta",
  "block.minecraft.cut_red_sandstone": "Iska yaree sanduuqa casaanka ah",
  "block.minecraft.cut_red_sandstone_slab": "Cut Red Sandstone Slab",
  "block.minecraft.cut_sandstone": "Iska yaree sanduuqa",
  "block.minecraft.cut_sandstone_slab": "Iska yaree Sandstone Slab",
  "block.minecraft.cyan_banner": "Calan Buluug Khafiif Ah",
  "block.minecraft.cyan_bed": "Sariirta cran",
  "block.minecraft.cyan_candle": "Shumaca Cyan",
  "block.minecraft.cyan_candle_cake": "Keeg leh Shumaca Cyan",
  "block.minecraft.cyan_carpet": "Cyan kaarbadka",
  "block.minecraft.cyan_concrete": "Cury la taaban karo",
  "block.minecraft.cyan_concrete_powder": "Cyan Budada La Taaban Karo",
  "block.minecraft.cyan_glazed_terracotta": "Cran glazed Terracotta",
  "block.minecraft.cyan_shulker_box": "Sanduuqa Crancan Shulker",
  "block.minecraft.cyan_stained_glass": "Cyan wasakheeyey Glass",
  "block.minecraft.cyan_stained_glass_pane": "Cyan wasakheeyey Murayaad",
  "block.minecraft.cyan_terracotta": "Cyan Terracotta",
  "block.minecraft.cyan_wool": "Cyan Wool",
  "block.minecraft.damaged_anvil": "Xudun yar oo jabtay",
  "block.minecraft.dandelion": "Løvetann",
  "block.minecraft.dark_oak_button": "Badhanka Oak madow",
  "block.minecraft.dark_oak_door": "Madow oak albaabka",
  "block.minecraft.dark_oak_fence": "Dark Oak Fence",
  "block.minecraft.dark_oak_fence_gate": "Albaabka madow ee Oak Fence",
  "block.minecraft.dark_oak_hanging_sign": "Dark Oak Hanging Sign",
  "block.minecraft.dark_oak_leaves": "Dark Oak Leaves",
  "block.minecraft.dark_oak_log": "Mishiinka madow",
  "block.minecraft.dark_oak_planks": "Qorshooyin Mugdi ah Miro",
  "block.minecraft.dark_oak_pressure_plate": "Cadaadiska Cadaadiska Acacia",
  "block.minecraft.dark_oak_sapling": "Madow Oak Sapling",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Dhirta madow saxiix",
  "block.minecraft.dark_oak_slab": "Madow Dhuxusha Xargaha",
  "block.minecraft.dark_oak_stairs": "Madow Dhuxusha Jaranjaro",
  "block.minecraft.dark_oak_trapdoor": "Madow oak albaabka",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Oak Wall Hanging Sign",
  "block.minecraft.dark_oak_wall_sign": "Saxiixa Mugta Dhuxusha",
  "block.minecraft.dark_oak_wood": "Dhirta madow geedka",
  "block.minecraft.dark_prismarine": "Maskax madoobaadka",
  "block.minecraft.dark_prismarine_slab": "Madow Prismarine Xargaha",
  "block.minecraft.dark_prismarine_stairs": "Jaranjarada Prismarine Jaranjarada",
  "block.minecraft.daylight_detector": "Qalabka maalinlaha",
  "block.minecraft.dead_brain_coral": "Coral Maskaxda Dhintay",
  "block.minecraft.dead_brain_coral_block": "Dhimashada maskaxda maskaxda maskaxda",
  "block.minecraft.dead_brain_coral_fan": "Fankii Coral Maskaxda Dhintay",
  "block.minecraft.dead_brain_coral_wall_fan": "Maskaxda Dhintay Taageeraha Darbiga Coral",
  "block.minecraft.dead_bubble_coral": "Coral Xumbo Dhintay",
  "block.minecraft.dead_bubble_coral_block": "Coral xumbo dhintay xannibaad",
  "block.minecraft.dead_bubble_coral_fan": "Fan Xumbo Coral Fan",
  "block.minecraft.dead_bubble_coral_wall_fan": "Xumbo dhintay Coral Wall Fan",
  "block.minecraft.dead_bush": "Baadiyaha Dhintay",
  "block.minecraft.dead_fire_coral": "Dhuxul Dabka Dhimatay",
  "block.minecraft.dead_fire_coral_block": "Dhuxul Dabka Dhimatay xannibaad",
  "block.minecraft.dead_fire_coral_fan": "Fanaanka Dabka Dhimatay",
  "block.minecraft.dead_fire_coral_wall_fan": "Dabka dhintay Taageeraha Darbiga Coral",
  "block.minecraft.dead_horn_coral": "CoralHorn Dhintay",
  "block.minecraft.dead_horn_coral_block": "Dhimashada Coral Hom xannibaad",
  "block.minecraft.dead_horn_coral_fan": "Fanaanka geeska geeska dhintay",
  "block.minecraft.dead_horn_coral_wall_fan": "Dabka dhintay Taageeraha Darbiga Coral",
  "block.minecraft.dead_tube_coral": "Coral Tube Dhintay",
  "block.minecraft.dead_tube_coral_block": "Tube dhintay Coral Block\n",
  "block.minecraft.dead_tube_coral_fan": "Tube Dhintay Coral Fan",
  "block.minecraft.dead_tube_coral_wall_fan": "Tube dhintay Coral Wall Coral",
  "block.minecraft.decorated_pot": "Decorated Pot",
  "block.minecraft.deepslate": "Qeexid",
  "block.minecraft.deepslate_brick_slab": "Leben dhagaxa qoto dheer jaranjaro",
  "block.minecraft.deepslate_brick_stairs": "Leben dhagaxa qoto dheer jaranjaro",
  "block.minecraft.deepslate_brick_wall": "Leben dhagaxa qoto dheer derbi",
  "block.minecraft.deepslate_bricks": "Leben dhagaxa qoto dheer",
  "block.minecraft.deepslate_coal_ore": "Dhuxusha qotada dheereysa",
  "block.minecraft.deepslate_copper_ore": "Deepslate Naxaaska Copper",
  "block.minecraft.deepslate_diamond_ore": "Qoto dheer dheeman dheeman",
  "block.minecraft.deepslate_emerald_ore": "Qoto-dheer oo qoto dheer",
  "block.minecraft.deepslate_gold_ore": "Qoto dheer oo dahab ah",
  "block.minecraft.deepslate_iron_ore": "Qoto dheer ee Birta",
  "block.minecraft.deepslate_lapis_ore": "Qoto dheer oo jilicsan lapis lazuli ore",
  "block.minecraft.deepslate_redstone_ore": "Qoto-dheer oo guduudan oo guduudan",
  "block.minecraft.deepslate_tile_slab": "Leben dhagaxa qoto dheer jaranjaro",
  "block.minecraft.deepslate_tile_stairs": "Leben dhagaxa qoto dheer jaranjaro",
  "block.minecraft.deepslate_tile_wall": "Leben dhagaxa qoto dheer derbi",
  "block.minecraft.deepslate_tiles": "Leben dhagaxa qoto dheer saxan",
  "block.minecraft.detector_rail": "Detector Rail",
  "block.minecraft.diamond_block": "Joojinta Ee Dheeman",
  "block.minecraft.diamond_ore": "Dheeman Dheeman",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Qolka diorite",
  "block.minecraft.diorite_stairs": "Jaranjarada diorite",
  "block.minecraft.diorite_wall": "Derbiga diorite",
  "block.minecraft.dirt": "Wasakh",
  "block.minecraft.dirt_path": "Wadada wasakhda ah",
  "block.minecraft.dispenser": "Fasax",
  "block.minecraft.dragon_egg": "Ukunta Masduulaagii",
  "block.minecraft.dragon_head": "Masduulaagii Maxada",
  "block.minecraft.dragon_wall_head": "Madaxa derbiga ee maskaxda",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Kelp qalalan",
  "block.minecraft.dripstone_block": "Dhibic dhagax Xannibaadda",
  "block.minecraft.dropper": "Cajiin",
  "block.minecraft.emerald_block": "Block of Emerald",
  "block.minecraft.emerald_ore": "Emerald Ore",
  "block.minecraft.enchanting_table": "miiska sixirka",
  "block.minecraft.end_gateway": "Dhamee albaabka",
  "block.minecraft.end_portal": "Xariirka dhamaadka",
  "block.minecraft.end_portal_frame": "Qaabka End Portal",
  "block.minecraft.end_rod": "Dhamaadka usha",
  "block.minecraft.end_stone": "dhagax dhamaadka",
  "block.minecraft.end_stone_brick_slab": "Soo afjaro lebbiska dhagxaanta",
  "block.minecraft.end_stone_brick_stairs": "Joojiya jaranjarada lebenka dhagaxa",
  "block.minecraft.end_stone_brick_wall": "Dheji derbiga lebbiska dhagaxa",
  "block.minecraft.end_stone_bricks": "Dhamaadka dhagaxa dhagaxa",
  "block.minecraft.ender_chest": "Weelka Ender",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Naxaas la kashifay",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Naxaas Goos Goos ah",
  "block.minecraft.exposed_cut_copper_slab": "Basaasid Goobo Nabar",
  "block.minecraft.exposed_cut_copper_stairs": "Jaranjarooyinka Copper Cut",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Beeraley",
  "block.minecraft.fern": "Fern",
  "block.minecraft.fire": "Fire",
  "block.minecraft.fire_coral": "Dhuxul Dabka",
  "block.minecraft.fire_coral_block": "Dab-damiska Dab_damiska",
  "block.minecraft.fire_coral_fan": "Fanaanka Xidigaha Geeska",
  "block.minecraft.fire_coral_wall_fan": "Dabka Taageeraha Darbiga Coral",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Miis jeexan",
  "block.minecraft.flower_pot": "Dheriga ubaxa",
  "block.minecraft.flowering_azalea": "Azalea",
  "block.minecraft.flowering_azalea_leaves": "Caleemaha Azalea",
  "block.minecraft.frogspawn": "Frogspawn",
  "block.minecraft.frosted_ice": "Frosted Ice",
  "block.minecraft.furnace": "Furnace",
  "block.minecraft.gilded_blackstone": "Gilded Blackstone",
  "block.minecraft.glass": "Galaas",
  "block.minecraft.glass_pane": "Murayaad",
  "block.minecraft.glow_lichen": "Glow Lichen",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Block oo dahab",
  "block.minecraft.gold_ore": "Hadal dahab ah",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Boorashka Granite",
  "block.minecraft.granite_stairs": "Jaranjarada granite",
  "block.minecraft.granite_wall": "Derbiga granite",
  "block.minecraft.grass": "Cows",
  "block.minecraft.grass_block": "Block Grass",
  "block.minecraft.gravel": "Isbahaysiga",
  "block.minecraft.gray_banner": "Calan Cawlan",
  "block.minecraft.gray_bed": "Sariir Rasaasi",
  "block.minecraft.gray_candle": "Shumaca Gray",
  "block.minecraft.gray_candle_cake": "Keeg leh Shumaca Gray",
  "block.minecraft.gray_carpet": "Gray kaarbadka",
  "block.minecraft.gray_concrete": "La taaban karo",
  "block.minecraft.gray_concrete_powder": "Dameeri Budada La Taaban Karo",
  "block.minecraft.gray_glazed_terracotta": "Oranji glazed terracotta",
  "block.minecraft.gray_shulker_box": "Sanduuqa cawlan",
  "block.minecraft.gray_stained_glass": "Gray wasakheeyey Glass",
  "block.minecraft.gray_stained_glass_pane": "Gray wasakheeyey Murayaad",
  "block.minecraft.gray_terracotta": "Grey Terracotta",
  "block.minecraft.gray_wool": "Wool cirro",
  "block.minecraft.green_banner": "Calan Cagaaran",
  "block.minecraft.green_bed": "Sariir cagaaran",
  "block.minecraft.green_candle": "Shumaca Cagaaran",
  "block.minecraft.green_candle_cake": "Keeg leh Shumaca Cagaaran",
  "block.minecraft.green_carpet": "Green kaarbadka",
  "block.minecraft.green_concrete": "Cagaaran La Taaban Karo",
  "block.minecraft.green_concrete_powder": "Cagaar Budada La Taaban Karo",
  "block.minecraft.green_glazed_terracotta": "Grown Glazed Terracotta",
  "block.minecraft.green_shulker_box": "Sanduuqa cagaaran",
  "block.minecraft.green_stained_glass": "Green wasakheeyey Glass",
  "block.minecraft.green_stained_glass_pane": "Green wasakheeyey Murayaad",
  "block.minecraft.green_terracotta": "Green Terracotta",
  "block.minecraft.green_wool": "Wool cagaaran",
  "block.minecraft.grindstone": "Garaacid",
  "block.minecraft.hanging_roots": "Xididdada sudhan",
  "block.minecraft.hay_block": "Sheaf ee hay",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Culayska Cadaadiska culus",
  "block.minecraft.honey_block": "Honey Block",
  "block.minecraft.honeycomb_block": "Xanibida malab",
  "block.minecraft.hopper": "Miro hod lagu dhisan",
  "block.minecraft.horn_coral": "Horn Coral",
  "block.minecraft.horn_coral_block": "Xayndaabka Geeska",
  "block.minecraft.horn_coral_fan": "Fanaanka Xidigaha Geeska",
  "block.minecraft.horn_coral_wall_fan": "Dabka Taageeraha Darbiga Coral",
  "block.minecraft.ice": "Baraf",
  "block.minecraft.infested_chiseled_stone_bricks": "bulukeeti xardho",
  "block.minecraft.infested_cobblestone": "cudurka loo yaqaan ",
  "block.minecraft.infested_cracked_stone_bricks": "Lebenkii qoray Stone",
  "block.minecraft.infested_deepslate": "Siman qoto dheer dhagax",
  "block.minecraft.infested_mossy_stone_bricks": "Lebenkii qoray Stone",
  "block.minecraft.infested_stone": "dhagax la jeexay",
  "block.minecraft.infested_stone_bricks": "Lebenkii qoray Stone",
  "block.minecraft.iron_bars": "Baararka Iron",
  "block.minecraft.iron_block": "Block ee Iron",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Iron Door",
  "block.minecraft.iron_ore": "Iron Mare",
  "block.minecraft.iron_trapdoor": "Birch Hatch",
  "block.minecraft.jack_o_lantern": "Jack oLantern",
  "block.minecraft.jigsaw": "Xujo jigsaw",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Jungle Button",
  "block.minecraft.jungle_door": "Jungle albaabka",
  "block.minecraft.jungle_fence": "Jungle Fence",
  "block.minecraft.jungle_fence_gate": "Albaabka kaymaha Jungle",
  "block.minecraft.jungle_hanging_sign": "Jungle Hanging Sign",
  "block.minecraft.jungle_leaves": "Hawdka caleen",
  "block.minecraft.jungle_log": "Diiwaangelinta jungle",
  "block.minecraft.jungle_planks": "Qorshaha Jungle",
  "block.minecraft.jungle_pressure_plate": "Cadaadiska Cadaadiska Jungle",
  "block.minecraft.jungle_sapling": "Jungle Sapling",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Duurjoogta saxiix",
  "block.minecraft.jungle_slab": "Duurjoogta Xargaha",
  "block.minecraft.jungle_stairs": "Duurjoogta Jaranjaro",
  "block.minecraft.jungle_trapdoor": "Jungle Trapdoor",
  "block.minecraft.jungle_wall_hanging_sign": "Jungle Wall Hanging Sign",
  "block.minecraft.jungle_wall_sign": "Duurjoogta derbiga saxiix",
  "block.minecraft.jungle_wood": "Hawdka alwaax",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelp Plant",
  "block.minecraft.ladder": "Ladder",
  "block.minecraft.lantern": "Cirifka",
  "block.minecraft.lapis_block": "Block Lapis Lazuli",
  "block.minecraft.lapis_ore": "Lapis Lazuli Ore",
  "block.minecraft.large_amethyst_bud": "Bud weyn oo Ametusti ah",
  "block.minecraft.large_fern": "Large Fern",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lava Cauldron",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Lectern",
  "block.minecraft.lever": "Lever",
  "block.minecraft.light": "Iftiin",
  "block.minecraft.light_blue_banner": "Calan Buluug Khafiif Ah",
  "block.minecraft.light_blue_bed": "Sariir Qafiif Buluug",
  "block.minecraft.light_blue_candle": "Shumac Buluug Iftiin ah",
  "block.minecraft.light_blue_candle_cake": "Keeg leh Shumac Fudud oo Buluug ah",
  "block.minecraft.light_blue_carpet": "Light Blue kaarbadka",
  "block.minecraft.light_blue_concrete": "Buluug buluug ah oo fudud",
  "block.minecraft.light_blue_concrete_powder": "Iftiin Buluug Budada La Taaban Karo",
  "block.minecraft.light_blue_glazed_terracotta": "Blass buluug iftiin leh oo buluug ah",
  "block.minecraft.light_blue_shulker_box": "Sanduuqa shalker buluug ah oo fudud",
  "block.minecraft.light_blue_stained_glass": "Light Blue wasakheeyey Glass",
  "block.minecraft.light_blue_stained_glass_pane": "Light Blue wasakheeyey Murayaad",
  "block.minecraft.light_blue_terracotta": "Light Blue Terracotta",
  "block.minecraft.light_blue_wool": "Light Blue Wool",
  "block.minecraft.light_gray_banner": "Calan Cawlan Fudud",
  "block.minecraft.light_gray_bed": "Sariir cawlan oo fudud",
  "block.minecraft.light_gray_candle": "Shumac Fudud",
  "block.minecraft.light_gray_candle_cake": "Keeg leh Shumac Fudud",
  "block.minecraft.light_gray_carpet": "Light Gray kaarbadka",
  "block.minecraft.light_gray_concrete": "Iftiiminta cawlan",
  "block.minecraft.light_gray_concrete_powder": "Iftiin Dameeri Budada La Taaban Karo",
  "block.minecraft.light_gray_glazed_terracotta": "Grod Fer Tracotta",
  "block.minecraft.light_gray_shulker_box": "Sanduuqa Shuck Schker fudud",
  "block.minecraft.light_gray_stained_glass": "Light Gray wasakheeyey Glass",
  "block.minecraft.light_gray_stained_glass_pane": "Light Gray wasakheeyey Murayaad",
  "block.minecraft.light_gray_terracotta": "Iftiimin Gray Terracotta",
  "block.minecraft.light_gray_wool": "Wool Light Grey Light",
  "block.minecraft.light_weighted_pressure_plate": "Cadaadiska Cadaadiska Iftiiminta Khafiifka ah",
  "block.minecraft.lightning_rod": "Usha Hillaaca",
  "block.minecraft.lilac": "Lilac",
  "block.minecraft.lily_of_the_valley": "Tufaaxa dooxada",
  "block.minecraft.lily_pad": "Lily Pad",
  "block.minecraft.lime_banner": "Calan Cagaaran Oo Khafiif Ah",
  "block.minecraft.lime_bed": "Sariir Lime",
  "block.minecraft.lime_candle": "Shumaca Liinta",
  "block.minecraft.lime_candle_cake": "Keeg leh Shumaca Lime",
  "block.minecraft.lime_carpet": "Lime kaarbadka",
  "block.minecraft.lime_concrete": "Akhtar Cagaaran La Taaban Karo too",
  "block.minecraft.lime_concrete_powder": "Akhtar Budada La Taaban Karo",
  "block.minecraft.lime_glazed_terracotta": "Cadcad cad oo loo yaqaan Terracotta",
  "block.minecraft.lime_shulker_box": "Sanduuqa lime Sholker",
  "block.minecraft.lime_stained_glass": "Lime wasakheeyey Glass",
  "block.minecraft.lime_stained_glass_pane": "Lime wasakheeyey Murayaad",
  "block.minecraft.lime_terracotta": "Lime Terracotta",
  "block.minecraft.lime_wool": "Lime Wool",
  "block.minecraft.lodestone": "Lodestone",
  "block.minecraft.loom": "Dhar",
  "block.minecraft.magenta_banner": "Calan Magenta",
  "block.minecraft.magenta_bed": "Sariir Magenta",
  "block.minecraft.magenta_candle": "Magenta Shumaca",
  "block.minecraft.magenta_candle_cake": "Keeg leh Magenta Shumaca",
  "block.minecraft.magenta_carpet": "Magenta kaarbadka",
  "block.minecraft.magenta_concrete": "Basalicarwaajis La Taaban Karo",
  "block.minecraft.magenta_concrete_powder": "Basalicarwaajis Budada La Taaban Karo",
  "block.minecraft.magenta_glazed_terracotta": "Cadcad cad oo loo yaqaan Terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shuller sanduuqa",
  "block.minecraft.magenta_stained_glass": "Magenta wasakheeyey Glass",
  "block.minecraft.magenta_stained_glass_pane": "Magenta wasakheeyey Murayaad",
  "block.minecraft.magenta_terracotta": "Magenta Terracotta",
  "block.minecraft.magenta_wool": "Magenta Wool",
  "block.minecraft.magma_block": "Dhagaxa Block",
  "block.minecraft.mangrove_button": "Badhanka Mangrove",
  "block.minecraft.mangrove_door": "Albaabka Mangrove",
  "block.minecraft.mangrove_fence": "Dayrka Mangrove",
  "block.minecraft.mangrove_fence_gate": "Albaabka Deedka Mangrove",
  "block.minecraft.mangrove_hanging_sign": "Mangrove Hanging Sign",
  "block.minecraft.mangrove_leaves": "Caleenta Mangrove",
  "block.minecraft.mangrove_log": "Diiwaan Gelinta Mangrove",
  "block.minecraft.mangrove_planks": "Looxaan mangrove",
  "block.minecraft.mangrove_pressure_plate": "Saxanka Cadaadiska Mangrove",
  "block.minecraft.mangrove_propagule": "Faafin Mangrove",
  "block.minecraft.mangrove_roots": "Xididda Mangrove",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Calaamadda Mangrove",
  "block.minecraft.mangrove_slab": "Slab Mangrove",
  "block.minecraft.mangrove_stairs": "Jaranjarada Mangrove",
  "block.minecraft.mangrove_trapdoor": "Mangrove LogMangrove Trapdoor",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrove Wall Hanging Sign",
  "block.minecraft.mangrove_wall_sign": "Calaamadda gidaarka Mangrove",
  "block.minecraft.mangrove_wood": "Qoryaha Mangrove",
  "block.minecraft.medium_amethyst_bud": "Dhexdhexaad Amethyst Bud",
  "block.minecraft.melon": "Qaraha",
  "block.minecraft.melon_stem": "Qaraha qaraha",
  "block.minecraft.moss_block": "Moss xannibaadda",
  "block.minecraft.moss_carpet": "Rooga moss",
  "block.minecraft.mossy_cobblestone": "Ajaa Cawska",
  "block.minecraft.mossy_cobblestone_slab": "Mossy cottonblestone slab",
  "block.minecraft.mossy_cobblestone_stairs": "Jaranjarooyinka mossy",
  "block.minecraft.mossy_cobblestone_wall": "Darbiga dhagxaanta Mossy",
  "block.minecraft.mossy_stone_brick_slab": "Lebbiska dhagxaanta dhagaxa ah",
  "block.minecraft.mossy_stone_brick_stairs": "Jaranjarooyinka lebiska dhagaxa ah",
  "block.minecraft.mossy_stone_brick_wall": "Derbiga lebiska dhagaxa ah",
  "block.minecraft.mossy_stone_bricks": "Jaranjarooyinka lebiska dhagaxa ah",
  "block.minecraft.moving_piston": "Dhaqaaqin Galab",
  "block.minecraft.mud": "Dhoobo",
  "block.minecraft.mud_brick_slab": "Duubka dhoobada",
  "block.minecraft.mud_brick_stairs": "Jaranjaro dhoobo ah",
  "block.minecraft.mud_brick_wall": "Derbiga dhoobada ah",
  "block.minecraft.mud_bricks": "Leben dhoobo ah",
  "block.minecraft.muddy_mangrove_roots": "Xididdada Mangrove Muddy",
  "block.minecraft.mushroom_stem": "Mushroom Stem",
  "block.minecraft.mycelium": "Mycelium",
  "block.minecraft.nether_brick_fence": "xayndaabka nezer",
  "block.minecraft.nether_brick_slab": "Nether Brick Slab",
  "block.minecraft.nether_brick_stairs": "Jaranjarada Nether Brick",
  "block.minecraft.nether_brick_wall": "Derbiga lebiska",
  "block.minecraft.nether_bricks": "lebenkii jahannamada",
  "block.minecraft.nether_gold_ore": "Nether Gold Ore",
  "block.minecraft.nether_portal": "Xulka Nether Portal",
  "block.minecraft.nether_quartz_ore": "Jutchz",
  "block.minecraft.nether_sprouts": "Noocyada ee loo yaqaan 'Nether Sprouts'",
  "block.minecraft.nether_wart": "Nether Wart",
  "block.minecraft.nether_wart_block": "Kala Soco Wart Block",
  "block.minecraft.netherite_block": "Block of Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Xusuus qor",
  "block.minecraft.oak_button": "Oak Button",
  "block.minecraft.oak_door": "Oak albaabka",
  "block.minecraft.oak_fence": "Bowd Oak",
  "block.minecraft.oak_fence_gate": "Albaabka Oak Fence",
  "block.minecraft.oak_hanging_sign": "Oak Hanging Sign",
  "block.minecraft.oak_leaves": "Oak Leaves",
  "block.minecraft.oak_log": "Qoraallo kulul",
  "block.minecraft.oak_planks": "Qorshooyin Mugdi",
  "block.minecraft.oak_pressure_plate": "Mashiinka cadaadiska",
  "block.minecraft.oak_sapling": "Oak Sapling",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Calaamadda maqalka",
  "block.minecraft.oak_slab": "Dhuxusha Xargaha",
  "block.minecraft.oak_stairs": "Oak Stairs",
  "block.minecraft.oak_trapdoor": "Oak Trapdoor",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall Hanging Sign",
  "block.minecraft.oak_wall_sign": "Derbiga weyn saxiix",
  "block.minecraft.oak_wood": "Oak Wood",
  "block.minecraft.observer": "Fiirso",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ochre Froglight",
  "block.minecraft.ominous_banner": "Calanka Xun",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Calan Oranji",
  "block.minecraft.orange_bed": "Sariir Burtiqaal",
  "block.minecraft.orange_candle": "Shumaca Liinta",
  "block.minecraft.orange_candle_cake": "Ku kariso Shumaca Liinta",
  "block.minecraft.orange_carpet": "Orange kaarbadka",
  "block.minecraft.orange_concrete": "La taaban karo oranji",
  "block.minecraft.orange_concrete_powder": "Liimi Budada La Taaban Karo",
  "block.minecraft.orange_glazed_terracotta": "Oranji glazed terracotta",
  "block.minecraft.orange_shulker_box": "Sanduuqa shalker oranji",
  "block.minecraft.orange_stained_glass": "Orange wasakheeyey Glass",
  "block.minecraft.orange_stained_glass_pane": "Orange wasakheeyey Murayaad",
  "block.minecraft.orange_terracotta": "Orange Terracotta",
  "block.minecraft.orange_tulip": "Orange Tulip",
  "block.minecraft.orange_wool": "Orange Wool",
  "block.minecraft.oxeye_daisy": "Oxeye Daisy",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Copper Oxidized",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Copper Oxidized",
  "block.minecraft.oxidized_cut_copper_slab": "Dharka Nadiifinta Nadiifinta",
  "block.minecraft.oxidized_cut_copper_stairs": "Jaranjarooyinka Naxaasta La Jarjaray",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Ice buuxiyey",
  "block.minecraft.packed_mud": "Mud la soo buuxiyay",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Albaabka Deedka Cad",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Iftiinka ubaxa",
  "block.minecraft.peony": "Peony",
  "block.minecraft.petrified_oak_slab": "Petvidence Oak Slab",
  "block.minecraft.piglin_head": "Piglin Head",
  "block.minecraft.piglin_wall_head": "Piglin Wall Head",
  "block.minecraft.pink_banner": "Calan Casaan Ah",
  "block.minecraft.pink_bed": "Sariir basaly",
  "block.minecraft.pink_candle": "Shumac casaan",
  "block.minecraft.pink_candle_cake": "Keeg leh Shumaca Casaanka ah",
  "block.minecraft.pink_carpet": "Pink kaarbadka",
  "block.minecraft.pink_concrete": "Basali La Taaban Karo",
  "block.minecraft.pink_concrete_powder": "Basali Budada La Taaban Karo",
  "block.minecraft.pink_glazed_terracotta": "Casaan dhalaalaya Terracotta",
  "block.minecraft.pink_petals": "Pink Petals",
  "block.minecraft.pink_shulker_box": "Sanduuqa shalker pink",
  "block.minecraft.pink_stained_glass": "Pink wasakheeyey Glass",
  "block.minecraft.pink_stained_glass_pane": "Pink wasakheeyey Murayaad",
  "block.minecraft.pink_terracotta": "Pink Terracotta",
  "block.minecraft.pink_tulip": "Ubax Guduudan Khafiif",
  "block.minecraft.pink_wool": "Pink Wool",
  "block.minecraft.piston": "Qalab",
  "block.minecraft.piston_head": "Galab Madaxa",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Madaxa cayaaraha",
  "block.minecraft.player_head.named": "%s's Madaxa",
  "block.minecraft.player_wall_head": "Madaxa gidaarka Ciyaaryahanka",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Dhibic dhagax tilmaamaya",
  "block.minecraft.polished_andesite": "Smooth Andesite",
  "block.minecraft.polished_andesite_slab": "Daboolan oo laysku qurxiyo",
  "block.minecraft.polished_andesite_stairs": "Jaranjarooyinka laysku qurxiyo",
  "block.minecraft.polished_basalt": "Polished Basalt",
  "block.minecraft.polished_blackstone": "Polished Blackstone",
  "block.minecraft.polished_blackstone_brick_slab": "Polished Blackstone Brick Slab",
  "block.minecraft.polished_blackstone_brick_stairs": "Polished Blackstone Brick Stairs",
  "block.minecraft.polished_blackstone_brick_wall": "Polished Blackstone Brick Wall",
  "block.minecraft.polished_blackstone_bricks": "Polished Blackstone Bricks",
  "block.minecraft.polished_blackstone_button": "Polished Blackstone Button",
  "block.minecraft.polished_blackstone_pressure_plate": "Polished Blackstone Pressure Plate",
  "block.minecraft.polished_blackstone_slab": "Polished Blackstone Slab",
  "block.minecraft.polished_blackstone_stairs": "Polished Blackstone Stairs",
  "block.minecraft.polished_blackstone_wall": "Polished Blackstone Wall",
  "block.minecraft.polished_deepslate": "Siman qoto dheer dhagax",
  "block.minecraft.polished_deepslate_slab": "Siman qoto dheer dhagax saxan",
  "block.minecraft.polished_deepslate_stairs": "Siman qoto dheer dhagax jaranjaro",
  "block.minecraft.polished_deepslate_wall": "Siman qoto dheer dhagax derbi",
  "block.minecraft.polished_diorite": "Granite Polished",
  "block.minecraft.polished_diorite_slab": "Daboolka diorite ee dhalaalaya",
  "block.minecraft.polished_diorite_stairs": "Daboolka diorite ee dhalaalaya",
  "block.minecraft.polished_granite": "Granite Polished",
  "block.minecraft.polished_granite_slab": "Daboolan cajalad leh",
  "block.minecraft.polished_granite_stairs": "Jaranjaro granite leh",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Casaan ubax",
  "block.minecraft.potatoes": "Baradha",
  "block.minecraft.potted_acacia_sapling": "Dhirta Acacia Ee Dheriga Ubaxa",
  "block.minecraft.potted_allium": "Allium Ee Dheriga Ubaxa",
  "block.minecraft.potted_azalea_bush": "Dhoobada Azalea",
  "block.minecraft.potted_azure_bluet": "Dheriga Azure Bluet",
  "block.minecraft.potted_bamboo": "Bambo qadhaadh ah",
  "block.minecraft.potted_birch_sapling": "Dhirta Birch Ee Dheriga Ubaxa",
  "block.minecraft.potted_blue_orchid": "Buluug Orchid Ee Dheriga Ubaxa",
  "block.minecraft.potted_brown_mushroom": "\nMushroom Brown ah oo la kariyey",
  "block.minecraft.potted_cactus": "Castrated Tictus",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Dhirta la kariyey",
  "block.minecraft.potted_crimson_fungus": "Potted Crimson Fungus",
  "block.minecraft.potted_crimson_roots": "Potted Crimson Roots",
  "block.minecraft.potted_dandelion": "Dandelion Ee Dheriga Ubaxa",
  "block.minecraft.potted_dark_oak_sapling": "Dhirta Mugdi Ah Oak Ee Dheriga Ubaxa",
  "block.minecraft.potted_dead_bush": "Duurka loo yaqaan pott",
  "block.minecraft.potted_fern": "fern dheri",
  "block.minecraft.potted_flowering_azalea_bush": "Caleemaha Ubax Azalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Dhirta Jungle Ee Dheriga Ubaxa",
  "block.minecraft.potted_lily_of_the_valley": "Laydi dhoobo ah ee dooxada",
  "block.minecraft.potted_mangrove_propagule": "Dacaayadda Mangrove ee dheriga ah",
  "block.minecraft.potted_oak_sapling": "Dhirta Oak Ee Dheriga Ubaxa",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Dheriga Orange Tulip",
  "block.minecraft.potted_oxeye_daisy": "\nPotted Oxeye Daisy",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Potted Pink Tulip",
  "block.minecraft.potted_poppy": "Poppy Ee Dheriga Ubaxa",
  "block.minecraft.potted_red_mushroom": "Boqoshaada cas",
  "block.minecraft.potted_red_tulip": "Dheriga Cas Tulip",
  "block.minecraft.potted_spruce_sapling": "Dhirta Spruce Ee Dheriga Ubaxa",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "Potted Warped Fungus",
  "block.minecraft.potted_warped_roots": "Potted Warped Roots",
  "block.minecraft.potted_white_tulip": "Dheriga Caddaan Tulip",
  "block.minecraft.potted_wither_rose": "Qallajiyey qadhaadh",
  "block.minecraft.powder_snow": "Barafka budada ah",
  "block.minecraft.powder_snow_cauldron": "Budada Barafka Cauldron",
  "block.minecraft.powered_rail": "Powered Rail",
  "block.minecraft.prismarine": "Prismarinium",
  "block.minecraft.prismarine_brick_slab": "Prismarine Lebbiska Xargaha",
  "block.minecraft.prismarine_brick_stairs": "Prismarine Lebbiska Jaranjaro",
  "block.minecraft.prismarine_bricks": "Prismarine Lebbiska Xargaha",
  "block.minecraft.prismarine_slab": "Prismarine Xargaha",
  "block.minecraft.prismarine_stairs": "Jaranjarada Prismarine",
  "block.minecraft.prismarine_wall": "Derbiga prismarine",
  "block.minecraft.pumpkin": "Pumpkin",
  "block.minecraft.pumpkin_stem": "Stem Steam",
  "block.minecraft.purple_banner": "Calan Guduudan",
  "block.minecraft.purple_bed": "Sariir guduudan",
  "block.minecraft.purple_candle": "Shumaca Purple",
  "block.minecraft.purple_candle_cake": "Cake la Shumaca Purple",
  "block.minecraft.purple_carpet": "Purple kaarbadka",
  "block.minecraft.purple_concrete": "Si la taaban karo oo la taaban karo",
  "block.minecraft.purple_concrete_powder": "Carwaajis Budada La Taaban Karo",
  "block.minecraft.purple_glazed_terracotta": "Buluug gropled terracotta",
  "block.minecraft.purple_shulker_box": "Sanduuqa Shuckper",
  "block.minecraft.purple_stained_glass": "Purple wasakheeyey Glass",
  "block.minecraft.purple_stained_glass_pane": "Purple wasakheeyey Murayaad",
  "block.minecraft.purple_terracotta": "Purple Terracotta",
  "block.minecraft.purple_wool": "Wple Wool",
  "block.minecraft.purpur_block": "Ujeeddada foosha",
  "block.minecraft.purpur_pillar": "Tiirarka Ujacaa",
  "block.minecraft.purpur_slab": "Ujeeddooyin Slab",
  "block.minecraft.purpur_stairs": "Jaranjarooyinka Ujeeddada",
  "block.minecraft.quartz_block": "Xannibaadda quarterz",
  "block.minecraft.quartz_bricks": "Quartz Bricks",
  "block.minecraft.quartz_pillar": "Tilmaamaha rubuc",
  "block.minecraft.quartz_slab": "Quartz Slab",
  "block.minecraft.quartz_stairs": "Jaranjarooyinka rubuc",
  "block.minecraft.rail": "Rail",
  "block.minecraft.raw_copper_block": "Block of Copper",
  "block.minecraft.raw_gold_block": "Block ee Iron",
  "block.minecraft.raw_iron_block": "Block ee Iron",
  "block.minecraft.red_banner": "Calan Cas",
  "block.minecraft.red_bed": "Sariirta gaduudan",
  "block.minecraft.red_candle": "Shumaca Casaanka ah",
  "block.minecraft.red_candle_cake": "Keeg leh Shumaca Casaanka ah",
  "block.minecraft.red_carpet": "Red kaarbadka",
  "block.minecraft.red_concrete": "La taaban karo",
  "block.minecraft.red_concrete_powder": "Casaan Budada La Taaban Karo",
  "block.minecraft.red_glazed_terracotta": "Casaan Madxafka Terracotta",
  "block.minecraft.red_mushroom": "Likaha guduudan",
  "block.minecraft.red_mushroom_block": "Cube likaha casaan",
  "block.minecraft.red_nether_brick_slab": "Lebbiska casaanka cas",
  "block.minecraft.red_nether_brick_stairs": "Jaranjarooyinka lebiska cas",
  "block.minecraft.red_nether_brick_wall": "Derbiga lebiska cas",
  "block.minecraft.red_nether_bricks": "Casaan dhalaalaysa",
  "block.minecraft.red_sand": "Red Sand",
  "block.minecraft.red_sandstone": "Casaan Sandstone",
  "block.minecraft.red_sandstone_slab": "Red Sandstone Slab",
  "block.minecraft.red_sandstone_stairs": "Jaranjarooyinka Cas ee Dhagaxa ah",
  "block.minecraft.red_sandstone_wall": "Derbiga sandstone sanduuqa",
  "block.minecraft.red_shulker_box": "Sanduuqa Red Sholker",
  "block.minecraft.red_stained_glass": "Red wasakheeyey Glass",
  "block.minecraft.red_stained_glass_pane": "Red wasakheeyey Murayaad",
  "block.minecraft.red_terracotta": "Red Terracotta",
  "block.minecraft.red_tulip": "Ubax guduudan",
  "block.minecraft.red_wool": "Wool cas",
  "block.minecraft.redstone_block": "Block of Redstone",
  "block.minecraft.redstone_lamp": "Laydhka Redstone",
  "block.minecraft.redstone_ore": "Redstone Ore",
  "block.minecraft.redstone_torch": "Redstone Shuclada",
  "block.minecraft.redstone_wall_torch": "Redstone Wall Torch",
  "block.minecraft.redstone_wire": "Redstone xadhig",
  "block.minecraft.reinforced_deepslate": "Dib-u-xoojinta Deepslate",
  "block.minecraft.repeater": "Dhagaxa cas ee soo noqnoqda",
  "block.minecraft.repeating_command_block": "Ku celcelinta leben amarka",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Respawn Anchor",
  "block.minecraft.rooted_dirt": "Wasakh xididdada",
  "block.minecraft.rose_bush": "Rose Bush",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstone",
  "block.minecraft.sandstone_slab": "Sandstone bulukeeti",
  "block.minecraft.sandstone_stairs": "Jaranjarooyinka Sandstone",
  "block.minecraft.sandstone_wall": "Derbiga dhagax ciid",
  "block.minecraft.scaffolding": "Xayiraad",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Caloosha Caloosha",
  "block.minecraft.sculk_sensor": "Sensor Sculk",
  "block.minecraft.sculk_shrieker": "Sculk Shrieker",
  "block.minecraft.sculk_vein": "Sculk Vein",
  "block.minecraft.sea_lantern": "Badda Faynuus",
  "block.minecraft.sea_pickle": "Qajaar badda",
  "block.minecraft.seagrass": "Seagrass",
  "block.minecraft.set_spawn": "Respawn point set",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Shroomlight",
  "block.minecraft.shulker_box": "Sanduuqa Sholle",
  "block.minecraft.skeleton_skull": "Qalfoofka skeleton",
  "block.minecraft.skeleton_wall_skull": "Qalfoofka darbiga",
  "block.minecraft.slime_block": "Xannibaadda slime",
  "block.minecraft.small_amethyst_bud": "Bud yar oo Amethyst ah",
  "block.minecraft.small_dripleaf": "Ifplat yar",
  "block.minecraft.smithing_table": "Miiska jumlada",
  "block.minecraft.smoker": "Sigaarka",
  "block.minecraft.smooth_basalt": "Basalt siman",
  "block.minecraft.smooth_quartz": "Smooth Quartz Block",
  "block.minecraft.smooth_quartz_slab": "Gogol xajin ah",
  "block.minecraft.smooth_quartz_stairs": "Jaranjarada quartz oo siman",
  "block.minecraft.smooth_red_sandstone": "Siman Red sandstone",
  "block.minecraft.smooth_red_sandstone_slab": "Daboolka sanduuqa cas ee casaanka ah",
  "block.minecraft.smooth_red_sandstone_stairs": "Jaranjarada sandstone dhagax casaan leh",
  "block.minecraft.smooth_sandstone": "Sandstone siman",
  "block.minecraft.smooth_sandstone_slab": "Sanduuqa dhagaxa sanduuqa ah",
  "block.minecraft.smooth_sandstone_stairs": "Jaranjarada sandstone siman",
  "block.minecraft.smooth_stone": "Smooth Stone",
  "block.minecraft.smooth_stone_slab": "Santuuq dhagax siman",
  "block.minecraft.sniffer_egg": "Sniffer Egg",
  "block.minecraft.snow": "Snow",
  "block.minecraft.snow_block": "Barafka barafka",
  "block.minecraft.soul_campfire": "Soul Campfire",
  "block.minecraft.soul_fire": "Soul Fire",
  "block.minecraft.soul_lantern": "Soul Lantern",
  "block.minecraft.soul_sand": "Soul ciid",
  "block.minecraft.soul_soil": "Soul Soil",
  "block.minecraft.soul_torch": "Soul Torch",
  "block.minecraft.soul_wall_torch": "Soul Wall Torch",
  "block.minecraft.spawn.not_valid": "Ma haysatid guriga sariirta ama eedeeyay barroosinka reappearance, ama waxaa la bixi waaya",
  "block.minecraft.spawner": "Monster Spawner",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "Isbonji",
  "block.minecraft.spore_blossom": "Spore Blossom",
  "block.minecraft.spruce_button": "Spruce Button",
  "block.minecraft.spruce_door": "Dhir albaabka",
  "block.minecraft.spruce_fence": "Bowd gran",
  "block.minecraft.spruce_fence_gate": "Albaabada Spruce Fence",
  "block.minecraft.spruce_hanging_sign": "Spruce Hanging Sign",
  "block.minecraft.spruce_leaves": "Gran Leaves",
  "block.minecraft.spruce_log": "Daadi taariikhda",
  "block.minecraft.spruce_planks": "Qorshaha Deedka",
  "block.minecraft.spruce_pressure_plate": "Daadi saxanka cadaadiska",
  "block.minecraft.spruce_sapling": "Daadi Sapling",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Dhir saxiix",
  "block.minecraft.spruce_slab": "Dhir Xargaha",
  "block.minecraft.spruce_stairs": "Dhir Jaranjaro",
  "block.minecraft.spruce_trapdoor": "Spruce Trapdoor",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall Hanging Sign",
  "block.minecraft.spruce_wall_sign": "Daaqada derbiga saxiix",
  "block.minecraft.spruce_wood": "Gran Wood",
  "block.minecraft.sticky_piston": "Dhegdheg qalab",
  "block.minecraft.stone": "Dhagax",
  "block.minecraft.stone_brick_slab": "Dhagax dhagax",
  "block.minecraft.stone_brick_stairs": "Jaranjarada Dhagaxa Dhagaxa",
  "block.minecraft.stone_brick_wall": "Derbiga lebbiska",
  "block.minecraft.stone_bricks": "Stone Bricks",
  "block.minecraft.stone_button": "Stone Button",
  "block.minecraft.stone_pressure_plate": "Cadaadiska Cadaadiska dhagaxa",
  "block.minecraft.stone_slab": "Stone bulukeeti",
  "block.minecraft.stone_stairs": "Jaranjarada dhagaxa",
  "block.minecraft.stonecutter": "Dhagxaan",
  "block.minecraft.stripped_acacia_log": "Diiwaan Gelinta Acacia",
  "block.minecraft.stripped_acacia_wood": "Stacpped Acacia Wood",
  "block.minecraft.stripped_bamboo_block": "Block of Stripped Bamboo",
  "block.minecraft.stripped_birch_log": "Xarig Bir Ah",
  "block.minecraft.stripped_birch_wood": "Alwaax gubatay",
  "block.minecraft.stripped_cherry_log": "Log cherry la jeexay",
  "block.minecraft.stripped_cherry_wood": "Qoryaha Cherry ee la furay",
  "block.minecraft.stripped_crimson_hyphae": "Stripped Crimson Hyphae",
  "block.minecraft.stripped_crimson_stem": "Stripped Crimson Stem",
  "block.minecraft.stripped_dark_oak_log": "Qufulkii loo yaqaan",
  "block.minecraft.stripped_dark_oak_wood": "Dhuftay madow Oak Wood",
  "block.minecraft.stripped_jungle_log": "Diiwaanka Jungle",
  "block.minecraft.stripped_jungle_wood": "Dhuftay Jungle",
  "block.minecraft.stripped_mangrove_log": "Log Mangrove oo la jeexay",
  "block.minecraft.stripped_mangrove_wood": "Qoryaha Mangrove ee la furay",
  "block.minecraft.stripped_oak_log": "Stripped Oak Log",
  "block.minecraft.stripped_oak_wood": "Dhuftay Oak",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Stripped Spruce Log",
  "block.minecraft.stripped_spruce_wood": "Alwaax la gooyay",
  "block.minecraft.stripped_warped_hyphae": "Stripped Warped Hyphae",
  "block.minecraft.stripped_warped_stem": "Stripped Warped Stem",
  "block.minecraft.structure_block": "Block Block",
  "block.minecraft.structure_void": "Qaab dhismeed madhan",
  "block.minecraft.sugar_cane": "Sugar Cane",
  "block.minecraft.sunflower": "Gabbaldayaha",
  "block.minecraft.suspicious_gravel": "Quruxdii laga shakiyay",
  "block.minecraft.suspicious_sand": "Ciid laga shakiyo",
  "block.minecraft.sweet_berry_bush": "Baadiyaha berry macaan",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Cows dheer",
  "block.minecraft.tall_seagrass": "Tall Seagrass",
  "block.minecraft.target": "Bartilmaameed",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Muraayadaha Madoow",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Torch",
  "block.minecraft.torchflower": "Ubax",
  "block.minecraft.torchflower_crop": "Dalagga Tooshka ah",
  "block.minecraft.trapped_chest": "Trapped Chest",
  "block.minecraft.trial_spawner": "Tijaabo Spawner",
  "block.minecraft.tripwire": "Tripwire",
  "block.minecraft.tripwire_hook": "Hook Tripwireka",
  "block.minecraft.tube_coral": "Tube Coral",
  "block.minecraft.tube_coral_block": "Tube Coral Block",
  "block.minecraft.tube_coral_fan": "Tube Coral Fan",
  "block.minecraft.tube_coral_wall_fan": "Tube Coral Wall Fan",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Tuff Tuff Slab",
  "block.minecraft.tuff_brick_stairs": "Jaranjarada Tuff Brick",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Lebenka",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff jaranjarada",
  "block.minecraft.tuff_wall": "Darbiga Tuff",
  "block.minecraft.turtle_egg": "Ukunta dixirka",
  "block.minecraft.twisting_vines": "Twisting Vines",
  "block.minecraft.twisting_vines_plant": "Twisting Vines Plant",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "Iftiimin Verdant",
  "block.minecraft.vine": "Vines",
  "block.minecraft.void_air": "Hawo ka bax",
  "block.minecraft.wall_torch": "Wall Torch",
  "block.minecraft.warped_button": "Warped Button",
  "block.minecraft.warped_door": "Warped Door",
  "block.minecraft.warped_fence": "Deyrka Buluugga ah",
  "block.minecraft.warped_fence_gate": "Warped Fence Gate",
  "block.minecraft.warped_fungus": "Warped Fungus",
  "block.minecraft.warped_hanging_sign": "Calaamadda Laallaabsan",
  "block.minecraft.warped_hyphae": "Warped Hyphae",
  "block.minecraft.warped_nylium": "Warped Nylium",
  "block.minecraft.warped_planks": "Warped Planks",
  "block.minecraft.warped_pressure_plate": "Warped Pressure Plate",
  "block.minecraft.warped_roots": "Warped Roots",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Warped Sign",
  "block.minecraft.warped_slab": "Warped Slab",
  "block.minecraft.warped_stairs": "Warped Stairs",
  "block.minecraft.warped_stem": "Warped Stem",
  "block.minecraft.warped_trapdoor": "Warped Trapdoor",
  "block.minecraft.warped_wall_hanging_sign": "Calaamadda gidaarka Laadlaadsan",
  "block.minecraft.warped_wall_sign": "Dagaallamay calaamadda darbiga",
  "block.minecraft.warped_wart_block": "Warped Wart Block",
  "block.minecraft.water": "Biyaha",
  "block.minecraft.water_cauldron": "Cauldron biyo",
  "block.minecraft.waxed_chiseled_copper": "Copper wax lagu shido",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Block Wax Copper ah",
  "block.minecraft.waxed_copper_bulb": "Naxaasta wax laga sameeyey",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Albaabka Naxaasta Dhuxul leh",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Shabakadda Copper Dhuxul leh",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Dababka Copper Dhuxul leh",
  "block.minecraft.waxed_cut_copper": "Waxed Cut Coppe",
  "block.minecraft.waxed_cut_copper_slab": "Waxed Cut Copper Slab",
  "block.minecraft.waxed_cut_copper_stairs": "Jaranjarooyinka Copper Waxed Cut",
  "block.minecraft.waxed_exposed_chiseled_copper": "Naxaasta Jiilaalaysan oo Dhuxaysan",
  "block.minecraft.waxed_exposed_copper": "Naxaas La Soo Bandhigay",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Naxaasta Dhuxul leh",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Albaabka Naxaasta ah ee Dhumay",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Shabag Naxaas ah oo Dhuxaysan",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Dabin Naxaas ah oo Dhumay",
  "block.minecraft.waxed_exposed_cut_copper": "Naxaas Goos Goos ah oo Soo Baxay",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Waxed Soo Bandhigay Nabad Naxaas",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Jaranjarooyinka Copper-ga ah ee Waxed Qaawan",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Chiseled Copper Waxed Oxidized",
  "block.minecraft.waxed_oxidized_copper": "Naxaas Lagu Dareemay Waxsoosaar",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Naxaasta Waxed Oxidized",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Albaabka naxaasta Oxidized",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Shabag naxaas ah oo Oxidized leh",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Dababka Copper ee Waxed Oxidized",
  "block.minecraft.waxed_oxidized_cut_copper": "Naxaaska La Qaxay ee Lagu Darey",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Waxsoosaar Cajiin ah oo Nadiif ah",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Jaranjarooyinka Copper-ga ah ee Waxsoosaaray",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Chiseled Copper oo wax lagu shiday",
  "block.minecraft.waxed_weathered_copper": "Naxa Weathered Copper",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Naxaas Weathered Copper",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Albaabka naxaasta ee wax lagu cimilay",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Shabag Naxaas ah oo Dhuxaysan",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Dabin Naxaas ah oo Weathered",
  "block.minecraft.waxed_weathered_cut_copper": "Naxa Weathered Jar Copper",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Waxed Weathered Jar Copper Slab",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Jaranjarooyinka Copper-ka ee Waxed Weedhered Gooyay",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Copper-jiifaysan oo cimilada leh",
  "block.minecraft.weathered_copper": "Copper Weathered",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Naxaasta Cimilada leh",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Albaabka Copper ee cimilada",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Shabakadda Copper ee cimilada",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Trapdoorka Copper ee cimilada leh",
  "block.minecraft.weathered_cut_copper": "\nCopper Weathered Jar",
  "block.minecraft.weathered_cut_copper_slab": "Jaranjarooyinka Copper Jarista Weathered",
  "block.minecraft.weathered_cut_copper_stairs": "Jaranjarooyinka Copper Jarista Weathered",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Weeping Vines",
  "block.minecraft.weeping_vines_plant": "Weeping Vines Plant",
  "block.minecraft.wet_sponge": "Isbonji qoyan",
  "block.minecraft.wheat": "Dalagyada qamadida",
  "block.minecraft.white_banner": "Calan Cad",
  "block.minecraft.white_bed": "Sariir Cad",
  "block.minecraft.white_candle": "Shumaca Cad",
  "block.minecraft.white_candle_cake": "Cake leh Shumaca Cad",
  "block.minecraft.white_carpet": "Caddaan kaarbadka",
  "block.minecraft.white_concrete": "Caddaan La Taaban Karo",
  "block.minecraft.white_concrete_powder": "Caddaan Budada La Taaban Karo",
  "block.minecraft.white_glazed_terracotta": "Cadcad cad oo loo yaqaan Terracotta",
  "block.minecraft.white_shulker_box": "Sanduuqa White Shulle",
  "block.minecraft.white_stained_glass": "White wasakheeyey Glass",
  "block.minecraft.white_stained_glass_pane": "White wasakheeyey Murayaad",
  "block.minecraft.white_terracotta": "White Terracotta",
  "block.minecraft.white_tulip": "Ubax Cad",
  "block.minecraft.white_wool": "White Wool",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Waaba kor u kacay",
  "block.minecraft.wither_skeleton_skull": "Qalfoofka Qalfoofka",
  "block.minecraft.wither_skeleton_wall_skull": "\nWither Skeleton Wall Skull",
  "block.minecraft.yellow_banner": "Calan Jaalle",
  "block.minecraft.yellow_bed": "Sariir Jaalo",
  "block.minecraft.yellow_candle": "Shumac Jaalo",
  "block.minecraft.yellow_candle_cake": "Kee la Shumaca Jaalaha ah",
  "block.minecraft.yellow_carpet": "Yellow kaarbadka",
  "block.minecraft.yellow_concrete": "Jaalle La Taaban Karo",
  "block.minecraft.yellow_concrete_powder": "Jaalle Budada La Taaban Karo",
  "block.minecraft.yellow_glazed_terracotta": "Huruud huruud ah oo huruud ah",
  "block.minecraft.yellow_shulker_box": "Sanduuqa shalker jaalaha ah",
  "block.minecraft.yellow_stained_glass": "Yellow wasakheeyey Glass",
  "block.minecraft.yellow_stained_glass_pane": "Yellow wasakheeyey Murayaad",
  "block.minecraft.yellow_terracotta": "Yellow Terracotta",
  "block.minecraft.yellow_wool": "Yellow Wool",
  "block.minecraft.zombie_head": "Madaxa Zombie",
  "block.minecraft.zombie_wall_head": "Madaxa Darbiga Zombie",
  "item.minecraft.acacia_boat": "Qudhac Doon",
  "item.minecraft.acacia_chest_boat": "Doomaha Acacia oo leh Chest",
  "item.minecraft.allay_spawn_egg": "Allay Ukun Dhaafe",
  "item.minecraft.amethyst_shard": "Amethyst Shard",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Tufaax",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Qosol",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Ukun",
  "item.minecraft.armor_stand": "Istaaga hubka",
  "item.minecraft.arms_up_pottery_shard": "Hubka Korriinka Dheriga Shard",
  "item.minecraft.arms_up_pottery_sherd": "Hubka Up Pottery Sherd",
  "item.minecraft.arrow": "Filaar",
  "item.minecraft.axolotl_bucket": "Baaldi ee Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Ukunta Axolotl",
  "item.minecraft.baked_potato": "Baradho la dubay",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft oo leh Laabta",
  "item.minecraft.bamboo_raft": "Bamboo Raft",
  "item.minecraft.bat_spawn_egg": "Bisad ku dhalatay ukunta",
  "item.minecraft.bee_spawn_egg": "Bee Spawn Egg",
  "item.minecraft.beef": "Hiib Lo Cayriin",
  "item.minecraft.beetroot": "Sharbeed",
  "item.minecraft.beetroot_seeds": "Abuurka Beetroot",
  "item.minecraft.beetroot_soup": "Maraqa Beetroot",
  "item.minecraft.birch_boat": "Bjørk Doon",
  "item.minecraft.birch_chest_boat": "Doomaha Birch leh Chest",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Dheeha madow",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "Budada ololaysa",
  "item.minecraft.blaze_rod": "Oul Oloeyes",
  "item.minecraft.blaze_spawn_egg": "Shinni Spawn Ukunta",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Dheeh buluug ah",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Ukun dhafoor ah",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Lafaha",
  "item.minecraft.bone_meal": "Cuntada lafaha",
  "item.minecraft.book": "Buug",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Qaansada",
  "item.minecraft.bowl": "Baqulo",
  "item.minecraft.bread": "Kibistii",
  "item.minecraft.breeze_rod": "Usha neecawda",
  "item.minecraft.breeze_spawn_egg": "Neecawda Ukun",
  "item.minecraft.brewer_pottery_shard": "Beerta dheriga Shard",
  "item.minecraft.brewer_pottery_sherd": "Beerta dheriga Sherd",
  "item.minecraft.brewing_stand": "Meesha Wax-qabashada",
  "item.minecraft.brick": "Leben",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Dheeha madow",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Caday",
  "item.minecraft.bucket": "Baaldi",
  "item.minecraft.bundle": "Xidhmo",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Gubi Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Ukunta Geela Dhalay",
  "item.minecraft.carrot": "Karoto",
  "item.minecraft.carrot_on_a_stick": "Karootada Usha",
  "item.minecraft.cat_spawn_egg": "Bisad ku dhalatay ukunta",
  "item.minecraft.cauldron": "Cauldron",
  "item.minecraft.cave_spider_spawn_egg": "Cadaadiska cagaaran ukunta spawn",
  "item.minecraft.chainmail_boots": "Kabaha Chainmail",
  "item.minecraft.chainmail_chestplate": "Shaxda Cheinmail",
  "item.minecraft.chainmail_helmet": "Koofiyadda Chainmail",
  "item.minecraft.chainmail_leggings": "Silsilad Lugaha",
  "item.minecraft.charcoal": "Dhuxul dhagax",
  "item.minecraft.cherry_boat": "Cherry Doon",
  "item.minecraft.cherry_chest_boat": "Doonta Cherry ee Laabta",
  "item.minecraft.chest_minecart": "Minecart oo leh Laab",
  "item.minecraft.chicken": "Digaag Cayriin",
  "item.minecraft.chicken_spawn_egg": "Ukunta digaagga",
  "item.minecraft.chorus_fruit": "Miraha Chorus",
  "item.minecraft.clay_ball": "Dhoobo Kubadda",
  "item.minecraft.clock": "Saacad",
  "item.minecraft.coal": "Dhuxul",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Bun",
  "item.minecraft.cod": "Codka cagaaran",
  "item.minecraft.cod_bucket": "Baaldi cod",
  "item.minecraft.cod_spawn_egg": "Bisad ku dhalatay ukunta",
  "item.minecraft.command_block_minecart": "Gaari miinada oo leh Taliska Joojinta",
  "item.minecraft.compass": "Kombas",
  "item.minecraft.cooked_beef": "Isteek",
  "item.minecraft.cooked_chicken": "Digaag Lakariyey",
  "item.minecraft.cooked_cod": "Codka la kariyey",
  "item.minecraft.cooked_mutton": "Hilib Ido Lakariyey",
  "item.minecraft.cooked_porkchop": "Porkchop la kariyey",
  "item.minecraft.cooked_rabbit": "Bakeylhe Lkarey",
  "item.minecraft.cooked_salmon": "Salmon la kariyey",
  "item.minecraft.cookie": "Buskut",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Copper Ingot",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Bisad ku dhalatay ukunta",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Qaabka xayeysiiska",
  "item.minecraft.creeper_banner_pattern.desc": "Qiimo badan",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Cadaadiska cagaaran ukunta spawn",
  "item.minecraft.crossbow": "Isbaaro",
  "item.minecraft.crossbow.projectile": "Mashruuc",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Cyran dheeh dheeh",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Khatarta dhoobada Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Doomaha Madow ee Geedka",
  "item.minecraft.dark_oak_chest_boat": "Doomaha Oak madow oo leh Chest",
  "item.minecraft.debug_stick": "Usha ka saar",
  "item.minecraft.debug_stick.empty": "%s hanti ma laha",
  "item.minecraft.debug_stick.select": "selected \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" to %s",
  "item.minecraft.diamond": "Dheeman",
  "item.minecraft.diamond_axe": "Misarta Damaymakah",
  "item.minecraft.diamond_boots": "Kabaha dheeman",
  "item.minecraft.diamond_chestplate": "Dheemanka dheeman",
  "item.minecraft.diamond_helmet": "Koofiyadda dheemanka",
  "item.minecraft.diamond_hoe": "Dheeman hoe",
  "item.minecraft.diamond_horse_armor": "Hubka Horse Dheeman",
  "item.minecraft.diamond_leggings": "Lugeynta dheemanka",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Burska Damaymakah",
  "item.minecraft.diamond_shovel": "Badiilka Damaymakah",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Seefta Damaymakah",
  "item.minecraft.disc_fragment_5": "Jajabka saxanka",
  "item.minecraft.disc_fragment_5.desc": "Qalabka Muusiga - 5",
  "item.minecraft.dolphin_spawn_egg": "Zoglin Spawn Egg",
  "item.minecraft.donkey_spawn_egg": "Dameer ukunta",
  "item.minecraft.dragon_breath": "Neefta Dragon",
  "item.minecraft.dried_kelp": "Balsi qalalan",
  "item.minecraft.drowned_spawn_egg": "Ukun u dhinta ukunta",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Echo Shard",
  "item.minecraft.egg": "Ukun",
  "item.minecraft.elder_guardian_spawn_egg": "Magangelyo oday ah ukunta",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Samurud",
  "item.minecraft.enchanted_book": "Buug la sixray",
  "item.minecraft.enchanted_golden_apple": "Tufaax Dahab ah oo la sixray",
  "item.minecraft.end_crystal": "Dhamaad Crystal",
  "item.minecraft.ender_dragon_spawn_egg": "Dragon Ende Spawn Ukun",
  "item.minecraft.ender_eye": "Indhaha dhamaadka",
  "item.minecraft.ender_pearl": "Ender Luul",
  "item.minecraft.enderman_spawn_egg": "Ukunta enderman",
  "item.minecraft.endermite_spawn_egg": "Ukunta u dhinta ukunta",
  "item.minecraft.evoker_spawn_egg": "Evoker Dhalin Ukun",
  "item.minecraft.experience_bottle": "Dhalo lagu sixro",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Baal",
  "item.minecraft.fermented_spider_eye": "Isha Caaro khamiirsan",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Khariidad",
  "item.minecraft.fire_charge": "Kharashka dabka",
  "item.minecraft.firework_rocket": "Gantaalka rashka",
  "item.minecraft.firework_rocket.flight": "Muddada Duulimaadka:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Xiddigta Dab-damiska",
  "item.minecraft.firework_star.black": "Madow",
  "item.minecraft.firework_star.blue": "Buluug",
  "item.minecraft.firework_star.brown": "Bunni",
  "item.minecraft.firework_star.custom_color": "Caadiyan",
  "item.minecraft.firework_star.cyan": "Cyan",
  "item.minecraft.firework_star.fade_to": "Ku libdhi",
  "item.minecraft.firework_star.flicker": "Maroojin",
  "item.minecraft.firework_star.gray": "Ciro",
  "item.minecraft.firework_star.green": "Cagaaran",
  "item.minecraft.firework_star.light_blue": "Light Blue",
  "item.minecraft.firework_star.light_gray": "Cirro khafiif ah",
  "item.minecraft.firework_star.lime": "Lime",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Basali",
  "item.minecraft.firework_star.purple": "Guduud",
  "item.minecraft.firework_star.red": "Casaan",
  "item.minecraft.firework_star.shape": "Qaab aan la aqoon",
  "item.minecraft.firework_star.shape.burst": "Dilaaca",
  "item.minecraft.firework_star.shape.creeper": "Creeper-qaabeeya",
  "item.minecraft.firework_star.shape.large_ball": "Kubad Weyn",
  "item.minecraft.firework_star.shape.small_ball": "Kubad Yar",
  "item.minecraft.firework_star.shape.star": "Xidig-qaabeeya",
  "item.minecraft.firework_star.trail": "Raad raac",
  "item.minecraft.firework_star.white": "White",
  "item.minecraft.firework_star.yellow": "Yellow",
  "item.minecraft.fishing_rod": "Usha kalluumeysiga",
  "item.minecraft.flint": "Dhagaxaan",
  "item.minecraft.flint_and_steel": "Flint iyo biraha",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Qaabka calanka",
  "item.minecraft.flow_banner_pattern.desc": "Socodka",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Dheriga Sherd",
  "item.minecraft.flower_banner_pattern": "Qaabka calanka",
  "item.minecraft.flower_banner_pattern.desc": "Kharashka ubaxa",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Dheriga ubaxa",
  "item.minecraft.fox_spawn_egg": "Dawaco wuxuu Dhaley Ukun",
  "item.minecraft.friend_pottery_shard": "Saaxiibka Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Saaxiibka Dheriga Sherd",
  "item.minecraft.frog_spawn_egg": "Ukun dhalo Rah",
  "item.minecraft.furnace_minecart": "Minecart oo leh Foorno",
  "item.minecraft.ghast_spawn_egg": "Ukunta xamaasada leh",
  "item.minecraft.ghast_tear": "Ilmo Qosol",
  "item.minecraft.glass_bottle": "Dhalada Ugadamabeysa",
  "item.minecraft.glistering_melon_slice": "Qaraha xarkaha qaraha",
  "item.minecraft.globe_banner_pattern": "Qaabka calanka",
  "item.minecraft.globe_banner_pattern.desc": "Caalamka",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Glow Berry",
  "item.minecraft.glow_ink_sac": "Glow Ink Sac",
  "item.minecraft.glow_item_frame": "Qaabka Shayga Glow",
  "item.minecraft.glow_squid_spawn_egg": "Glow Squid Spawn Egg",
  "item.minecraft.glowstone_dust": "Boodhka dhalaalaya",
  "item.minecraft.goat_horn": "Horn ari",
  "item.minecraft.goat_spawn_egg": "Bisad ku dhalatay ukunta",
  "item.minecraft.gold_ingot": "Bar dahab ah",
  "item.minecraft.gold_nugget": "Xabbad Dahab",
  "item.minecraft.golden_apple": "Tufaax dahab ah",
  "item.minecraft.golden_axe": "Farta dahabka",
  "item.minecraft.golden_boots": "Kabaha Dahabka ah",
  "item.minecraft.golden_carrot": "Karoto O Dahabah",
  "item.minecraft.golden_chestplate": "Chebtplate dahab ah",
  "item.minecraft.golden_helmet": "Koofiyad Dahab ah",
  "item.minecraft.golden_hoe": "Farta dahabka",
  "item.minecraft.golden_horse_armor": "Hubka Fardaha Dahabiga ah",
  "item.minecraft.golden_leggings": "Gogol dahab ah",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Dahab dahab ah",
  "item.minecraft.golden_shovel": "Badiilka Dahbakah",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Seefta Dahbakah",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Midabada cawlan",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Dheeh cagaaran",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Ilaaliyaha Ukunta Dhalin",
  "item.minecraft.gunpowder": "Gunpowyder",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Wadnaha Badda",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "Hoglin Spawn Egg",
  "item.minecraft.honey_bottle": "Honey Bottle",
  "item.minecraft.honeycomb": "Malab",
  "item.minecraft.hopper_minecart": "Minecart oo leh Hopper",
  "item.minecraft.horse_spawn_egg": "Faras wuxuu Dhaley Ukun",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Sherd",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "Xusuusnow Ukun Dhalin",
  "item.minecraft.ink_sac": "Kiishad Qad ah",
  "item.minecraft.iron_axe": "Misarta Birtah",
  "item.minecraft.iron_boots": "Kabaha birta",
  "item.minecraft.iron_chestplate": "Xabadka Birta",
  "item.minecraft.iron_golem_spawn_egg": "Barafka Golem Spawn Ukun",
  "item.minecraft.iron_helmet": "Koofiyadda Birta",
  "item.minecraft.iron_hoe": "Bir hoe",
  "item.minecraft.iron_horse_armor": "Hubka Faraska Birta",
  "item.minecraft.iron_ingot": "bir -gelinta",
  "item.minecraft.iron_leggings": "Lugaha Birta",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Xabbad Bir",
  "item.minecraft.iron_pickaxe": "Burska Birtah",
  "item.minecraft.iron_shovel": "Majarafad dhagax ah",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Seefto birta",
  "item.minecraft.item_frame": "Qaabka Shayga",
  "item.minecraft.jungle_boat": "Kaynta Doon",
  "item.minecraft.jungle_chest_boat": "Doomaha Jungle oo leh Chest",
  "item.minecraft.knowledge_book": "Buugga Aqoonta",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Baldi Dabha",
  "item.minecraft.lead": "Xadhig",
  "item.minecraft.leather": "Maqaar",
  "item.minecraft.leather_boots": "Kabaha Hargaha",
  "item.minecraft.leather_chestplate": "Dharka Maqaarka",
  "item.minecraft.leather_helmet": "Daboolka maqaarka",
  "item.minecraft.leather_horse_armor": "Hubka Horse Leather",
  "item.minecraft.leather_leggings": "Surwaalka hargaha",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Dhogorta dhalaalaya buluug",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Dheeh casaan ah",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Dheeh dheeh",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Daawada raagay",
  "item.minecraft.lingering_potion.effect.awkward": "Dawaynta Daahsoon",
  "item.minecraft.lingering_potion.effect.empty": "Daawada aan la farsamayn karin",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Qalab Joogta ah ee Iska-caabbinta Dabka",
  "item.minecraft.lingering_potion.effect.harming": "Daawada Daahinta",
  "item.minecraft.lingering_potion.effect.healing": "Daawada Daahinta",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Dheefta aan la arki karin ee raagay",
  "item.minecraft.lingering_potion.effect.leaping": "Dheefta raagay ee boodboodka",
  "item.minecraft.lingering_potion.effect.levitation": "Daawada Dib-u-noolaynta",
  "item.minecraft.lingering_potion.effect.luck": "Daawada Nasiibka",
  "item.minecraft.lingering_potion.effect.mundane": "Daawada Lingering ee Mundane",
  "item.minecraft.lingering_potion.effect.night_vision": "Daawada raagay ee Aragga Habeenka",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Daawada sunta oo raagta",
  "item.minecraft.lingering_potion.effect.regeneration": "Daawada Dib-u-noolaynta",
  "item.minecraft.lingering_potion.effect.slow_falling": "Daawada Joogtada ah ee Qunyar Dhacda",
  "item.minecraft.lingering_potion.effect.slowness": "Daawada raagay ee gaabis ah",
  "item.minecraft.lingering_potion.effect.strength": "Madada Xoogga",
  "item.minecraft.lingering_potion.effect.swiftness": "Daawada Daahsoon ee Degdegta",
  "item.minecraft.lingering_potion.effect.thick": "Maandooriyaha Dhuumasho Adag",
  "item.minecraft.lingering_potion.effect.turtle_master": "Daawada Raagay ee Sayidkii Qoolleyda",
  "item.minecraft.lingering_potion.effect.water": "Dhalada Biyaha raagay",
  "item.minecraft.lingering_potion.effect.water_breathing": "Biyaha Neefsashada ee raagay",
  "item.minecraft.lingering_potion.effect.weakness": "Daawada Daciifnimada",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Ari wuxuu Dhaley Ukun",
  "item.minecraft.lodestone_compass": "Dhagax Jiho Kombas",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenta Dheef",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magma creme",
  "item.minecraft.magma_cube_spawn_egg": "Magma Cube ukun dhaley",
  "item.minecraft.mangrove_boat": "Doomaha Mangrove",
  "item.minecraft.mangrove_chest_boat": "Doomaha Mangrove oo leh Chest",
  "item.minecraft.map": "Khariidad madhan",
  "item.minecraft.melon_seeds": "Abuurka qaraha",
  "item.minecraft.melon_slice": "Qalab dhoobo",
  "item.minecraft.milk_bucket": "Baaldi caano ah",
  "item.minecraft.minecart": "Rimor",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Shay",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Ukun dhalo mooshroom",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "Baqal wuxuu Dhaley Ukun",
  "item.minecraft.mushroom_stew": "Lugta likaha",
  "item.minecraft.music_disc_11": "Music Disc",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Cajalka Musgah",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Music Disc",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Music Disc",
  "item.minecraft.music_disc_blocks.desc": "C418 - xannibids",
  "item.minecraft.music_disc_cat": "Music Disc",
  "item.minecraft.music_disc_cat.desc": "C418 - bisad",
  "item.minecraft.music_disc_chirp": "Music Disc",
  "item.minecraft.music_disc_chirp.desc": "C418 - qaylo",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Music Disc",
  "item.minecraft.music_disc_far.desc": "C418 - fog",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Music Disc",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Music Disc",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Music Disc",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - dhinac kale",
  "item.minecraft.music_disc_pigstep": "Music Disc",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Music Disc",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Music Disc",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Music Disc",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Music Disc",
  "item.minecraft.music_disc_wait.desc": "C418 - sug",
  "item.minecraft.music_disc_ward": "Music Disc",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Hilib Ido Cayriin",
  "item.minecraft.name_tag": "Magaca",
  "item.minecraft.nautilus_shell": "Qolof Nautilus",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Birka Nether",
  "item.minecraft.nether_star": "Xidig Nether",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Netherite Axe",
  "item.minecraft.netherite_boots": "Netherite Boots",
  "item.minecraft.netherite_chestplate": "Netherite Chestplate",
  "item.minecraft.netherite_helmet": "Netherite Helmet",
  "item.minecraft.netherite_hoe": "Netherite Hoe",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netherite Ingot",
  "item.minecraft.netherite_leggings": "Netherite Leggings",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netherite Pickaxe",
  "item.minecraft.netherite_scrap": "Netherite Scrap",
  "item.minecraft.netherite_shovel": "Netherite Shovel",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netherite Sword",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Geed Doon",
  "item.minecraft.oak_chest_boat": "Oak Boat oo leh Chest",
  "item.minecraft.ocelot_spawn_egg": "Ocelot wuxuu Dhaley Ukun",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Dheeh oranji",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Rinjiyeyn",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Panda spawn ukunta",
  "item.minecraft.paper": "Waraaq",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Baqbaqaaq wuxuu Dhaley Ukun",
  "item.minecraft.phantom_membrane": "Dahaarka Phantom",
  "item.minecraft.phantom_spawn_egg": "Phantom wuxuu Dhaley Ukun",
  "item.minecraft.pig_spawn_egg": "Dofaarka wuxuu Dhaley Ukun",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "Cunto",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin Brute Spawn Egg",
  "item.minecraft.piglin_spawn_egg": "Piglin Spawn Egg",
  "item.minecraft.pillager_spawn_egg": "Pillager kalluunka ukun",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Dheeh casaan",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Shard dherya badan",
  "item.minecraft.plenty_pottery_sherd": "Sherd dherya badan",
  "item.minecraft.poisonous_potato": "Baradho Sunta leh",
  "item.minecraft.polar_bear_spawn_egg": "Ukunta taranka ee orso",
  "item.minecraft.popped_chorus_fruit": "Miraha Chorus ee soo booday",
  "item.minecraft.porkchop": "Porkchop ceeriin ah",
  "item.minecraft.potato": "Baradho",
  "item.minecraft.potion": "Daawada",
  "item.minecraft.potion.effect.awkward": "Daawada Caqliga leh",
  "item.minecraft.potion.effect.empty": "Qalab aan la farsamayn karin",
  "item.minecraft.potion.effect.fire_resistance": "Qalabka Iska-caabbinta Dabka",
  "item.minecraft.potion.effect.harming": "Oohinta Waxyeelaynta",
  "item.minecraft.potion.effect.healing": "Daawada bogsashada",
  "item.minecraft.potion.effect.infested": "Daawada Caabuqa",
  "item.minecraft.potion.effect.invisibility": "Daroogada la arki karin",
  "item.minecraft.potion.effect.leaping": "Maqaarka boodada",
  "item.minecraft.potion.effect.levitation": "Daroogada Dib-u-nooleynta",
  "item.minecraft.potion.effect.luck": "Daroogada Nasiib",
  "item.minecraft.potion.effect.mundane": "Mundane Potion",
  "item.minecraft.potion.effect.night_vision": "Daawada Aragga Habeenka",
  "item.minecraft.potion.effect.oozing": "Daawada Oozing",
  "item.minecraft.potion.effect.poison": "Dawaynta Sunta",
  "item.minecraft.potion.effect.regeneration": "Daroogada Dib-u-nooleynta",
  "item.minecraft.potion.effect.slow_falling": "Daroogada Qunyar Dhacda",
  "item.minecraft.potion.effect.slowness": "Daawada gaabis ah",
  "item.minecraft.potion.effect.strength": "Awoodda Daawada",
  "item.minecraft.potion.effect.swiftness": "Daawada degdega ah",
  "item.minecraft.potion.effect.thick": "Dheriga qaro weyn",
  "item.minecraft.potion.effect.turtle_master": "Daroogada Sayidkii Qoolleyda",
  "item.minecraft.potion.effect.water": "Dhalada Biyaha",
  "item.minecraft.potion.effect.water_breathing": "Daawada Neefsashada Biyaha",
  "item.minecraft.potion.effect.weakness": "Daawada gaabis ah",
  "item.minecraft.potion.effect.weaving": "Dhererka Tolmada",
  "item.minecraft.potion.effect.wind_charged": "Qalabka Dabaysha Dabaysha",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Hubka Korriinka Dheriga Shard",
  "item.minecraft.pottery_shard_prize": "Abaalmarinta Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Dheriga madaxa Shard",
  "item.minecraft.powder_snow_bucket": "Barafka budada ah",
  "item.minecraft.prismarine_crystals": "Kiristaalo Prismarine ah",
  "item.minecraft.prismarine_shard": "Prismarine Shard",
  "item.minecraft.prize_pottery_shard": "Abaalmarinta Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Abaalmarinta Dheriga Sherd",
  "item.minecraft.pufferfish": "Burfunshish",
  "item.minecraft.pufferfish_bucket": "Baaldiga Pufferfish",
  "item.minecraft.pufferfish_spawn_egg": "kalluunka dufan ee ukunta taranka",
  "item.minecraft.pumpkin_pie": "Shaambadaha",
  "item.minecraft.pumpkin_seeds": "Abuurka bocorka",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Dheedka buluuga ah",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Nether Quartz",
  "item.minecraft.rabbit": "Bakeylhe Cayriin",
  "item.minecraft.rabbit_foot": "Bakeyle Lugtiis",
  "item.minecraft.rabbit_hide": "Maraq bakayle",
  "item.minecraft.rabbit_spawn_egg": "Bakeyle wuhuu Dhaley Ukun",
  "item.minecraft.rabbit_stew": "Maraq bakayle",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Ravager Ukun dhalo",
  "item.minecraft.raw_copper": "Maarta ceeriin",
  "item.minecraft.raw_gold": "Codka cagaaran",
  "item.minecraft.raw_iron": "Bir ceyriin",
  "item.minecraft.recovery_compass": "Isku-darka Soo-kabashada",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Dheeha cas",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Boorka Redstone",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Hilib qurmay",
  "item.minecraft.saddle": "Kursi",
  "item.minecraft.salmon": "Clonn clon",
  "item.minecraft.salmon_bucket": "Baaldi salmon ah",
  "item.minecraft.salmon_spawn_egg": "Jader wuxuu Dhaley Ukun",
  "item.minecraft.scrape_pottery_sherd": "Xoq dheriga Sherd",
  "item.minecraft.scute": "Qosol",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Maqas",
  "item.minecraft.sheep_spawn_egg": "Ido wuxuu Dhaley Ukun",
  "item.minecraft.shelter_pottery_shard": "Hoyga Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Hoyga Pottery Sherd",
  "item.minecraft.shield": "Gaashaanka",
  "item.minecraft.shield.black": "Gaashaanka Madow",
  "item.minecraft.shield.blue": "Gaashaan Buluug",
  "item.minecraft.shield.brown": "Gaashaan Bunni Ah",
  "item.minecraft.shield.cyan": "Gaashaanka Cyan",
  "item.minecraft.shield.gray": "Gaashaanka Cawlan",
  "item.minecraft.shield.green": "Gaashaanka Cagaaran",
  "item.minecraft.shield.light_blue": "Gaashaanka Buluugga ah ee Fudud",
  "item.minecraft.shield.light_gray": "Gaashaanka Cawlan Fudud",
  "item.minecraft.shield.lime": "Gaashaanka Lime",
  "item.minecraft.shield.magenta": "Gaashaanka Magenta",
  "item.minecraft.shield.orange": "Gaashaanka liimi ah",
  "item.minecraft.shield.pink": "Gaashaanka Casaanka Ah",
  "item.minecraft.shield.purple": "Gaashaanka Guduudan",
  "item.minecraft.shield.red": "Gaashaanka Cas",
  "item.minecraft.shield.white": "Gaashaanka Cad",
  "item.minecraft.shield.yellow": "Gaashaan Jaalle",
  "item.minecraft.shulker_shell": "Shulker Qolof",
  "item.minecraft.shulker_spawn_egg": "Shulker wuxuu Dhaley Ukun",
  "item.minecraft.sign": "Saxeex",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Ukunta taranka ee kalluunka",
  "item.minecraft.skeleton_horse_spawn_egg": "Faraska Qolfafkah wuxuu Dhaley Ukun",
  "item.minecraft.skeleton_spawn_egg": "Qolfaf wuxuu Dhaley Ukun",
  "item.minecraft.skull_banner_pattern": "Qaabka calanka",
  "item.minecraft.skull_banner_pattern.desc": "Kharashka kafeega",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Dheriga madaxa Shard",
  "item.minecraft.skull_pottery_sherd": "Sherd Dharka dhakada",
  "item.minecraft.slime_ball": "Kubad kubbad",
  "item.minecraft.slime_spawn_egg": "Slime wuxuu Dhaley Ukun",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Waxay khusaysaa:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Ku dar ingot ama crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Hubka",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Ku dar gabal hub ah",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Kiristaalo",
  "item.minecraft.smithing_template.ingredients": "Waxyaabaha ay ka kooban yihiin:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Kudar Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Qalabka Dheemanka",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Ku dar hub dheeman, hub, ama qalab",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Cusboonaysii: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Ukun",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Barafka Golem Spawn Ukun",
  "item.minecraft.snowball": "Kubada Barafk",
  "item.minecraft.spectral_arrow": "Falaadha rooxaanta",
  "item.minecraft.spider_eye": "Isha Carada",
  "item.minecraft.spider_spawn_egg": "Aro wuxuu Dhaley Ukun",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Daawada dabaysha",
  "item.minecraft.splash_potion.effect.awkward": "Daawada Dabiiciga ah",
  "item.minecraft.splash_potion.effect.empty": "Daawada aan la Farsamayn karin",
  "item.minecraft.splash_potion.effect.fire_resistance": "Daawada Iska-caabbinta Dabka",
  "item.minecraft.splash_potion.effect.harming": "Daawada Waxyeelaynta",
  "item.minecraft.splash_potion.effect.healing": "Daawada Daadinta",
  "item.minecraft.splash_potion.effect.infested": "Faafidda Caabuqa",
  "item.minecraft.splash_potion.effect.invisibility": "Faafidda Maqnaanshaha",
  "item.minecraft.splash_potion.effect.leaping": "Biyo Faafinta ee Boodashada",
  "item.minecraft.splash_potion.effect.levitation": "Daawada faafinta ee Levitation",
  "item.minecraft.splash_potion.effect.luck": "Daawada Nasiibka",
  "item.minecraft.splash_potion.effect.mundane": "Daawada Faafinta Maandooriyaha",
  "item.minecraft.splash_potion.effect.night_vision": "Faafidda Aragga Habeenka",
  "item.minecraft.splash_potion.effect.oozing": "Daaqada Oozing",
  "item.minecraft.splash_potion.effect.poison": "Biyo Faafinta ee Boodashada",
  "item.minecraft.splash_potion.effect.regeneration": "Daroogada Dib-u-nooleynta",
  "item.minecraft.splash_potion.effect.slow_falling": "Biyo-soo-baxa Qunyar-dhaca",
  "item.minecraft.splash_potion.effect.slowness": "Daawada Dareemka Degdegga ah",
  "item.minecraft.splash_potion.effect.strength": "Daawada Waxyeelaynta",
  "item.minecraft.splash_potion.effect.swiftness": "Daawada Dareemka Degdegga ah",
  "item.minecraft.splash_potion.effect.thick": "Dheef-shiid kiimikaad",
  "item.minecraft.splash_potion.effect.turtle_master": "Dareere Sayidkii Qoolleyda",
  "item.minecraft.splash_potion.effect.water": "Dhalada Biyaha Dabaysha",
  "item.minecraft.splash_potion.effect.water_breathing": "Biyaha Neefsashada ee Biyaha",
  "item.minecraft.splash_potion.effect.weakness": "Daawada Daciifnimada",
  "item.minecraft.splash_potion.effect.weaving": "Biyo-daaqashada Dharka",
  "item.minecraft.splash_potion.effect.wind_charged": "Biyaha Dabaysha ee Dabaysha",
  "item.minecraft.spruce_boat": "Gran Doon",
  "item.minecraft.spruce_chest_boat": "Doomaha Spruce leh Chest",
  "item.minecraft.spyglass": "Spyglass",
  "item.minecraft.squid_spawn_egg": "Ukunta taranka dabacasaha",
  "item.minecraft.stick": "Oul",
  "item.minecraft.stone_axe": "Fan dhagxan",
  "item.minecraft.stone_hoe": "Dhagax adag",
  "item.minecraft.stone_pickaxe": "Dhagax ka qaatay",
  "item.minecraft.stone_shovel": "Majarafad dhagax ah",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Seefta dhagax",
  "item.minecraft.stray_spawn_egg": "Ukun dhalay oo dhumay",
  "item.minecraft.strider_spawn_egg": "Strider Spawn Egg",
  "item.minecraft.string": "Xadhig",
  "item.minecraft.sugar": "Sonkorta",
  "item.minecraft.suspicious_stew": "Feejignaan shaki",
  "item.minecraft.sweet_berries": "Berry macaan",
  "item.minecraft.tadpole_bucket": "Baaldiyo Tadpole",
  "item.minecraft.tadpole_spawn_egg": "Tadpole Spawn Ukun",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Fallaadhka Tilmaansan",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Falaadhi tibaaxeed oo aan la farsamayn karin",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Falaadhida Iska caabinta Dabka",
  "item.minecraft.tipped_arrow.effect.harming": "Fallaadha Waxyeelaynta",
  "item.minecraft.tipped_arrow.effect.healing": "Fallaadha bogsiinta",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Falaadh La'aanta",
  "item.minecraft.tipped_arrow.effect.leaping": "Falaadhida boodboodka",
  "item.minecraft.tipped_arrow.effect.levitation": "Falaadhidii Laawiyiintii",
  "item.minecraft.tipped_arrow.effect.luck": "Falaadh nasiib",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Falaadhida Aragga Habeenka",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Fallaadha Sunta",
  "item.minecraft.tipped_arrow.effect.regeneration": "Falaadhida Dib-u-noolaynta",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Falaadh qunyar dhaceysa",
  "item.minecraft.tipped_arrow.effect.slowness": "Falaadh gaabis ah",
  "item.minecraft.tipped_arrow.effect.strength": "Falaadhida Xoogga",
  "item.minecraft.tipped_arrow.effect.swiftness": "Falaadhida Degdega",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Falaadhkii Sayidkii Qoolleyda",
  "item.minecraft.tipped_arrow.effect.water": "Falaadh firidhsan",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Fallaadha Neefsashada Biyaha",
  "item.minecraft.tipped_arrow.effect.weakness": "Falaadh daciifnimo",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Minecart oo leh tnt",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "Totem ee dhimashada",
  "item.minecraft.trader_llama_spawn_egg": "Baayacmushtarka llama ukunta dhaley",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Kalluunka kuleylka ah",
  "item.minecraft.tropical_fish_bucket": "Baaldiga kalluunka kulaylaha",
  "item.minecraft.tropical_fish_spawn_egg": "Kallunnka kulaylaha ah ayaa dhasha ukun",
  "item.minecraft.turtle_helmet": "Qolof Didiin",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Diniin wuxuu Dhaley Ukun",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Vex wuxuu Dhaley Ukun",
  "item.minecraft.villager_spawn_egg": "Pillager kalluunka ukun",
  "item.minecraft.vindicator_spawn_egg": "Tuugta ukunta taranka",
  "item.minecraft.wandering_trader_spawn_egg": "Ganacsadaha warwareega ayaa ukun dhalay",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Ukunta U yeerista ee Ilaaliyaha",
  "item.minecraft.warped_fungus_on_a_stick": "Warped Fungus on a Stick",
  "item.minecraft.water_bucket": "Baaldi biyo ah",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Qamadi",
  "item.minecraft.wheat_seeds": "Badbaadiyaha",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Dheeha cad",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Dabaysha ayaa lagu dallacay",
  "item.minecraft.witch_spawn_egg": "Saxirad wuxuu Dhaley Ukun",
  "item.minecraft.wither_skeleton_spawn_egg": "Ukun taranka qallafsan",
  "item.minecraft.wither_spawn_egg": "Engegan wuxuu Dhaley Ukun",
  "item.minecraft.wolf_armor": "Uubato hub",
  "item.minecraft.wolf_spawn_egg": "Yeey wuxuu Dhaley Ukun",
  "item.minecraft.wooden_axe": "Alwaax alwaax ah",
  "item.minecraft.wooden_hoe": "Alwaax hoe",
  "item.minecraft.wooden_pickaxe": "Alwaax alwaax ah",
  "item.minecraft.wooden_shovel": "Majarafad alwaax ah",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Seef alwaax ah",
  "item.minecraft.writable_book": "Buug iyo quill",
  "item.minecraft.written_book": "Buug qorid",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Dheeha jaalaha ah",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglin Spawn Egg",
  "item.minecraft.zombie_horse_spawn_egg": "Faraska Zombie wuxuu Dhaley Ukun",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombie wuxuu Dhaley Ukun",
  "item.minecraft.zombie_villager_spawn_egg": "Tuulada Zombie ayaa dhalay ukun",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombified Piglin Spawn Egg"
}
export const so_so = items; 
